/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(48)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYSTEM_ENV; });
var BASE_URL_API = "https://circular.rxy.com.br/api";
var SYSTEM_ENV = 1; // 0 debug - 1 produção

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1ff5ea4b5043dee2773c80012448ac8.woff";

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:font/woff;base64,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"

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "HelveticaNeueLTStd-BlkCnO.otf?48be86a10eda99676362e574e5da6988";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_circular_vqt.png?e612f39e1f18fa88ae3e01095fc33818";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_circular_dia.png?de8863c29f90cb3c99ee5ce47ff5d52e";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_circular_niver.png?0db86573925fb12a9ba2183441f25b6a";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_outlet.png?a9b6fd0b336dcdfb2ab52bf237c58e3b";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_circular_maes.png?8a42de7b1fef50eed896dbf79bc12ce0";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "base_feirao.png?224530294d093b5788093c554a33d1f8";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1_placa_compra_inteligente.png": 114,
	"./1_rodapenov_.png": 115,
	"./_placa_compra_inteligente.png": 116,
	"./_rodapenov.png": 117,
	"./placa_ar_10x_s_1x9_carne.png": 118,
	"./placa_ar_10x_s_entr_s_juros.png": 119,
	"./placa_col_estof_10x_s_1x9_carne.png": 120,
	"./placa_col_estof_10x_s_entr_s_juros.png": 121,
	"./placa_compra_inteligente.png": 122,
	"./placa_infor_10x_s_1x9_carne.png": 123,
	"./placa_infor_10x_s_entr_s_juros.png": 124,
	"./placa_mov_10x_s_1x9_carne.png": 125,
	"./placa_mov_10x_s_entr_s_juros.png": 126,
	"./placa_moveis_10x_s_1x9_carne.png": 127,
	"./placa_moveis_10x_s_entr_s_juros.png": 128,
	"./placa_smart_10x_s_1x9_carne.png": 129,
	"./placa_smart_10x_s_entr_s_juros.png": 130,
	"./placa_td_loja_s_entr_s_juros.png": 131,
	"./placa_td_loja_s_juros_0x12_catao.png": 132,
	"./placa_td_loja_s_juros_1x9_carne.png": 133,
	"./placa_td_loja_s_juros_carne.png": 134,
	"./placa_td_loja_s_juros_cartoes.png": 135,
	"./rodapenov.png": 136
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ads-svgrepo-com.svg?141bf615a730732d4184b79f0b7af8a9";

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCircularNew_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de1e7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCircularNew_vue__ = __webpack_require__(81);
function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de1e7e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCircularNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de1e7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCircularNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "app",
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.removeClass(document.body, "body");
        this.removeClass(document.body, "tema-2");
        this.removeClass(document.body, "tema-3");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_side_menu_SideMenu_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_header_theme_HeaderTheme_vue__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    components: {
        'side-menu': __WEBPACK_IMPORTED_MODULE_0__shared_side_menu_SideMenu_vue__["a" /* default */],
        'header-theme': __WEBPACK_IMPORTED_MODULE_1__shared_header_theme_HeaderTheme_vue__["a" /* default */]
    },
    mounted: function mounted() {
        $(document).ready(function () {
            $('.collapsible').collapsible();
        });
    },
    data: function data() {
        return {
            breads: [{
                url: "#",
                title: "Home"
            }]
        };
    }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3128c6f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(63);
function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3128c6f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3128c6f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "side_menu",
    mounted: function mounted() {
        $(document).ready(function () {
            $('.collapsible').collapsible();
            $('.sidenav').sidenav();
        });
    }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTheme_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_697c0528_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTheme_vue__ = __webpack_require__(66);
function injectStyle (ssrContext) {
  __webpack_require__(64)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-697c0528"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTheme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_697c0528_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTheme_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'header-theme',
    props: ["breadcrumb"],
    mounted: function mounted() {
        $(document).ready(function () {
            $('.collapsible').collapsible();

            $('.dropdown-trigger').dropdown();
        });
    }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'login',

    mounted: function mounted() {
        var email = window.localStorage.getItem("user-email");
        if (email) {
            this.rememberEmail = true;

            this.user.email = email;
        }
    },


    methods: {
        onSubmit: function onSubmit(e) {
            var _this = this;

            e.preventDefault();

            this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/auth/login', this.user).then(function (response) {
                response.json().then(function (json) {
                    window.localStorage.setItem('user-token', json.token);

                    if (_this.rememberEmail) {
                        window.localStorage.setItem('user-email', _this.user.email);
                    }

                    _this.$router.push('/');
                });
            }, function (response) {
                // error callback
                alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.');
            });
        }
    },

    data: function data() {
        return {
            user: {
                email: '',
                password: ''
            },
            rememberEmail: false
        };
    }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'logout',
    mounted: function mounted() {
        var _this = this;

        window.localStorage.removeItem('user-token');

        setTimeout(function () {
            _this.$router.push('/login');
        }, 3000);
    }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_base_circular_new_BaseCircularNew_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'choice_template',
    components: {
        "base-circular-new": __WEBPACK_IMPORTED_MODULE_0__shared_base_circular_new_BaseCircularNew_vue__["a" /* default */]
    },
    mounted: function mounted() {
        $(document).ready(function () {
            $('.fixed-action-btn').floatingActionButton();

            $('.tooltipped').tooltip();
        });
    }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'choice_template',
    props: ["title", "subtitle", "step", "pagetitle"],
    mounted: function mounted() {
        $(document).ready(function () {
            $('.fixed-action-btn').floatingActionButton();

            $('.tooltipped').tooltip();
        });
    }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_autocomplete_Autocomplete_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_base_circular_new_BaseCircularNew_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'choice_products',
    components: {
        "base-circular-new": __WEBPACK_IMPORTED_MODULE_1__shared_base_circular_new_BaseCircularNew_vue__["a" /* default */],
        "autocomplete": __WEBPACK_IMPORTED_MODULE_0__shared_autocomplete_Autocomplete_vue__["a" /* default */],
        Money: __WEBPACK_IMPORTED_MODULE_2_v_money__["Money"]
    },
    data: function data() {
        return {
            qtd_itens: 0,
            products: [],
            products_to_send: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            }
        };
    },
    created: function created() {
        if (Number(this.$route.params.id_template) === 1) {
            this.qtd_itens = 2;
        } else if (Number(this.$route.params.id_template) === 2) {
            this.qtd_itens = 3;
        } else if (Number(this.$route.params.id_template) === 3) {
            this.qtd_itens = 4;
        } else if (Number(this.$route.params.id_template) === 4) {
            this.qtd_itens = 5;
        } else if (Number(this.$route.params.id_template) === 5) {
            this.qtd_itens = 6;
        } else if (Number(this.$route.params.id_template) === 6) {
            this.qtd_itens = 7;
        } else if (Number(this.$route.params.id_template) === 7) {
            this.qtd_itens = 8;
        } else if (Number(this.$route.params.id_template) === 8) {
            this.qtd_itens = 9;
        }

        for (var v = 1; v <= this.qtd_itens; v++) {
            this.products_to_send[v] = {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                code: null,
                features: "",
                without_entrance: false,
                without_interest: false,
                in_carne: false,
                in_card: false
            };
        }
    },
    mounted: function mounted() {
        var _this = this;

        var token = localStorage.getItem("user-token");

        this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* BASE_URL_API */] + '/products', { params: { token: token } }).then(function (response) {
            response.json().then(function (json) {
                console.log(json);
                _this.products = json;
            });
        }, function (response) {
            // error callback
            response.json().then(function (ret) {
                if (ret.error) if (ret.error === "Token expirado.") {
                    window.localStorage.removeItem("user-token");
                    _this.$router.push('/login');
                }
            });
        });
    },

    methods: {
        // Chama quando o item é selecionado no autocomplete e preenche todos os dados do produto.
        itemSelected: function itemSelected(item, index) {
            this.products_to_send[index].name = item.name;
            this.products_to_send[index].id = item.id;
            this.products_to_send[index].price = Number(item.preco).toFixed(2);
            this.products_to_send[index].sight_price = Number(item.preco).toFixed(2);
            this.products_to_send[index].forward_price = (Number(item.preco) / 100 * 10 + Number(item.preco)).toFixed(2);
            this.products_to_send[index].payment_x = 10;
            this.products_to_send[index].payment_price = (this.products_to_send[index].forward_price / this.products_to_send[index].payment_x).toFixed(2);
            this.products_to_send[index].code = item.codigo;
            this.products_to_send[index].features = item.caracteristicas;

            this.$forceUpdate();
        },

        // Gera a circular final
        nextStep: function nextStep() {
            var filtered = this.products_to_send.filter(function (el) {
                if (el != null) {
                    if (el.without_entrance) el.payment_x = "0+" + el.payment_x;else el.payment_x = "1+" + (parseInt(el.payment_x) - 1);

                    return true;
                } else {
                    return false;
                }
                return el != null;
            });
            console.log(filtered);
            this.$router.push({
                name: 'opcoes_circular',
                params: {
                    items: filtered,
                    qtd_itens: this.qtd_itens
                }
            });
        },

        // Calcula o valor da parcela ao digita um novo valor a prazo ou ao digitar uma nova quantidade de parcelas
        calculatePaymentPrice: function calculatePaymentPrice(index) {
            this.products_to_send[index].payment_price = (this.products_to_send[index].forward_price / this.products_to_send[index].payment_x).toFixed(2);
            this.$forceUpdate();
        },

        // Calcula o valor à prazo ao digitar um novo valor de parcela
        calculateForwardPrice: function calculateForwardPrice(index) {
            this.products_to_send[index].forward_price = (this.products_to_send[index].payment_price * this.products_to_send[index].payment_x).toFixed(2);
            this.$forceUpdate();
        },

        // Recalcula o valor ao selecionar sem juros
        calculateWithoutInterest: function calculateWithoutInterest(e, index) {
            if (e.target.checked) {
                this.products_to_send[index].forward_price = Number(this.products_to_send[index].sight_price).toFixed(2);
                this.$forceUpdate();
            } else {
                this.products_to_send[index].forward_price = (Number(this.products_to_send[index].price) / 100 * this.products_to_send[index].payment_x + Number(this.products_to_send[index].price)).toFixed(2);
                this.$forceUpdate();
            }
        }
    }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'autocomplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      search: '',
      results: [],
      result: {},
      isOpen: false
    };
  },

  methods: {
    onChange: function onChange() {
      this.isOpen = true;
      this.filterResults();
    },
    filterResults: function filterResults() {
      var _this = this;

      this.results = this.items.filter(function (item) {
        return item.label.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
      });
    },
    setResult: function setResult(result) {
      this.result = result;
      this.search = result.label;
      this.isOpen = false;
      this.$emit('selected', result);
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_base_circular_new_BaseCircularNew_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "choice_options",
  components: {
    "base-circular-new": __WEBPACK_IMPORTED_MODULE_0__shared_base_circular_new_BaseCircularNew_vue__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  data: function data() {
    return {
      abrangencia: null,
      cities: [],
      items: [],
      chamada: "",
      dtinicio: null,
      dtfim: null,
      theme: "",
      banner: "",
      background_color: ""
    };
  },
  created: function created() {
    this.items = this.$route.params.items;
  },
  mounted: function mounted() {
    var _this = this;

    $(document).ready(function () {
      $("select").formSelect();
    });

    var token = localStorage.getItem("user-token");

    this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* BASE_URL_API */] + "/cities", { params: { token: token } }).then(function (response) {
      response.json().then(function (json) {
        console.log(json);
        _this.cities = json.cities;
      });
    }, function (response) {
      // error callback
      response.json().then(function (ret) {
        if (ret.error) if (ret.error === "Token expirado.") {
          window.localStorage.removeItem("user-token");
          _this.$router.push("/login");
        }
      });
    });
  },

  methods: {
    generateCircular: function generateCircular() {
      var _this2 = this;

      if (this.chamada === "") {
        this.$swal("Preencha todos os dados", "O texto de chamada não foi preenchido!", "error");
        return;
      }

      if (this.dtinicio === null) {
        this.$swal("Preencha todos os dados", "A data de início não foi preenchida!", "error");
        return;
      }

      if (this.dtfim === null) {
        this.$swal("Preencha todos os dados", "A data final não foi preenchida!", "error");
        return;
      }

      if (this.abrangencia === null) {
        this.$swal("Preencha todos os dados", "Não foi selecionada nenhuma cidade na abrangência", "error");
        return;
      }

      var token = localStorage.getItem("user-token");

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* BASE_URL_API */] + "/generate-circular", {
        token: token,
        produtos: this.items
      }).then(function (response) {
        response.json().then(function (json) {
          _this2.$swal({
            title: "Na próxima tela, aguarde a imagem ser gerada. Após isso, basta clicar no botão Salvar Imagem.",
            showCancelButton: false
          }).then(function (result) {
            if (result.value) {
              // handle Confirm button click
              // result.value will contain `true` or the input value
              // console.log(json);
              var name_route = "";
              if (_this2.$route.params.qtd_itens === 2) {
                name_route = "gera_circular_2x";
              } else if (_this2.$route.params.qtd_itens === 3) {
                name_route = "gera_circular_3x";
              } else if (_this2.$route.params.qtd_itens === 4) {
                name_route = "gera_circular_4x";
              } else if (_this2.$route.params.qtd_itens === 5) {
                name_route = "gera_circular_5x";
              } else if (_this2.$route.params.qtd_itens === 6) {
                name_route = "gera_circular_6x";
              } else if (_this2.$route.params.qtd_itens === 7) {
                name_route = "gera_circular_7x";
              } else if (_this2.$route.params.qtd_itens === 8) {
                name_route = "gera_circular_8x";
              } else if (_this2.$route.params.qtd_itens === 9) {
                name_route = "gera_circular_9x";
              }

              _this2.$router.push({
                name: name_route,
                params: {
                  items: _this2.items,
                  abrangencia: _this2.abrangencia,
                  chamada: _this2.chamada,
                  dtinicio: _this2.dtinicio,
                  dtfim: _this2.dtfim,
                  theme: _this2.theme,
                  banner: _this2.banner,
                  background_color: _this2.background_color
                }
              });
            } else {
              // handle dismissals
              // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
            }
          });
        });
      }, function (response) {
        // error callback
        response.json().then(function (ret) {
          if (ret.error) if (ret.error === "Token expirado.") {
            window.localStorage.removeItem("user-token");
            _this2.$router.push("/login");
          }
        });
      });
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_side_menu_SideMenu_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_header_theme_HeaderTheme_vue__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "CircularList",
    components: {
        "side-menu": __WEBPACK_IMPORTED_MODULE_0__shared_side_menu_SideMenu_vue__["a" /* default */],
        "header-theme": __WEBPACK_IMPORTED_MODULE_1__shared_header_theme_HeaderTheme_vue__["a" /* default */]
    },
    mounted: function mounted() {
        console.log(this.rows.map(function (el) {
            return el.qtd_itens;
        }).reduce(function (accumulator, currentValue) {
            return Number(accumulator) + Number(currentValue);
        }));
    },
    data: function data() {
        return {
            breads: [{
                url: "/",
                title: "Home"
            }, {
                url: "#",
                title: "Gerar Circular"
            }],
            rows: [{
                id: 1,
                data: "18/02/2019",
                qtd_itens: 4
            }, {
                id: 2,
                data: "17/02/2019",
                qtd_itens: 2
            }, {
                id: 3,
                data: "16/02/2019",
                qtd_itens: 4
            }, {
                id: 4,
                data: "15/02/2019",
                qtd_itens: 2
            }]
        };
    }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';

        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 3) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';

        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';

        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';

        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 4) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 5) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);

        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance) this.product_5.options_buy = "Sem Entrada";else if (this.product_5.without_interest) this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card) this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne) this.product_5.options_buy += "Carnê";else if (this.product_5.in_card) this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 6) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_6: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);

        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance) this.product_5.options_buy = "Sem Entrada";else if (this.product_5.without_interest) this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card) this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne) this.product_5.options_buy += "Carnê";else if (this.product_5.in_card) this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }

        // Produto 6

        var txtCompleto6 = sliceWords(this.items[5].name + " ", 30);

        var firstLine6 = sliceWords(txtCompleto6, 18);
        txtCompleto6 = txtCompleto6.replace(firstLine6 + " ", "");
        var secondLine6 = sliceWords(txtCompleto6 + " ", 18);

        var lines6 = [firstLine6, secondLine6];

        this.product_6.name = lines6.join("<br />");
        this.product_6.sight_price = Number(this.items[5].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_6.forward_price = Number(this.items[5].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price6 = String(this.items[5].payment_price).split(".");
        this.product_6.payment_price = Number(payment_price6[0]);
        this.product_6.payment_price_cents = Number(payment_price6[1]);
        if (String(this.product_6.payment_price_cents).length < 2) {
            this.product_6.payment_price_cents = this.pad_with_zeroes(this.product_6.payment_price_cents, 2);
        }
        if (isNaN(this.product_6.payment_price_cents)) {
            this.product_6.payment_price_cents = '00';
        }
        this.product_6.payment_x = this.items[5].payment_x;
        this.product_6.code = this.items[5].code;
        this.product_6.feature = this.items[5].features;

        this.product_6.without_entrance = this.items[5].without_entrance;
        this.product_6.without_interest = this.items[5].without_interest;
        this.product_6.in_carne = this.items[5].in_carne;
        this.product_6.in_card = this.items[5].in_card;

        this.product_6.options_buy = '';
        if (this.product_6.without_entrance && this.product_6.without_interest) {
            this.product_6.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_6.without_entrance) this.product_6.options_buy = "Sem Entrada";else if (this.product_6.without_interest) this.product_6.options_buy = "Sem Juros";
        }

        if (this.product_6.without_entrance || this.product_6.without_interest) {
            if (this.product_6.in_carne || this.product_6.in_card) this.product_6.options_buy += " | ";
        }

        if (this.product_6.in_carne && this.product_6.in_card) {
            this.product_6.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_6.in_carne) this.product_6.options_buy += "Carnê";else if (this.product_6.in_card) this.product_6.options_buy += "Cartão";
        }

        this.product_6.options_buy = this.product_6.options_buy.split("|");
        if (this.product_6.options_buy.length > 1) {
            this.product_6.options_buy = this.product_6.options_buy.join("<br>");
        } else {
            this.product_6.options_buy = this.product_6.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 7) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_6: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_7: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);

        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance) this.product_5.options_buy = "Sem Entrada";else if (this.product_5.without_interest) this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card) this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne) this.product_5.options_buy += "Carnê";else if (this.product_5.in_card) this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }

        // Produto 6

        var txtCompleto6 = sliceWords(this.items[5].name + " ", 30);

        var firstLine6 = sliceWords(txtCompleto6, 18);
        txtCompleto6 = txtCompleto6.replace(firstLine6 + " ", "");
        var secondLine6 = sliceWords(txtCompleto6 + " ", 18);

        var lines6 = [firstLine6, secondLine6];

        this.product_6.name = lines6.join("<br />");
        this.product_6.sight_price = Number(this.items[5].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_6.forward_price = Number(this.items[5].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price6 = String(this.items[5].payment_price).split(".");
        this.product_6.payment_price = Number(payment_price6[0]);
        this.product_6.payment_price_cents = Number(payment_price6[1]);
        if (String(this.product_6.payment_price_cents).length < 2) {
            this.product_6.payment_price_cents = this.pad_with_zeroes(this.product_6.payment_price_cents, 2);
        }
        if (isNaN(this.product_6.payment_price_cents)) {
            this.product_6.payment_price_cents = '00';
        }
        this.product_6.payment_x = this.items[5].payment_x;
        this.product_6.code = this.items[5].code;
        this.product_6.feature = this.items[5].features;

        this.product_6.without_entrance = this.items[5].without_entrance;
        this.product_6.without_interest = this.items[5].without_interest;
        this.product_6.in_carne = this.items[5].in_carne;
        this.product_6.in_card = this.items[5].in_card;

        this.product_6.options_buy = '';
        if (this.product_6.without_entrance && this.product_6.without_interest) {
            this.product_6.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_6.without_entrance) this.product_6.options_buy = "Sem Entrada";else if (this.product_6.without_interest) this.product_6.options_buy = "Sem Juros";
        }

        if (this.product_6.without_entrance || this.product_6.without_interest) {
            if (this.product_6.in_carne || this.product_6.in_card) this.product_6.options_buy += " | ";
        }

        if (this.product_6.in_carne && this.product_6.in_card) {
            this.product_6.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_6.in_carne) this.product_6.options_buy += "Carnê";else if (this.product_6.in_card) this.product_6.options_buy += "Cartão";
        }

        this.product_6.options_buy = this.product_6.options_buy.split("|");
        if (this.product_6.options_buy.length > 1) {
            this.product_6.options_buy = this.product_6.options_buy.join("<br>");
        } else {
            this.product_6.options_buy = this.product_6.options_buy[0];
        }

        // Produto 7

        var txtCompleto7 = sliceWords(this.items[6].name + " ", 30);

        var firstLine7 = sliceWords(txtCompleto7, 18);
        txtCompleto7 = txtCompleto7.replace(firstLine7 + " ", "");
        var secondLine7 = sliceWords(txtCompleto7 + " ", 18);

        var lines7 = [firstLine7, secondLine7];

        this.product_7.name = lines7.join("<br />");
        this.product_7.sight_price = Number(this.items[6].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_7.forward_price = Number(this.items[6].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price7 = String(this.items[6].payment_price).split(".");
        this.product_7.payment_price = Number(payment_price7[0]);
        this.product_7.payment_price_cents = Number(payment_price7[1]);
        if (String(this.product_7.payment_price_cents).length < 2) {
            this.product_7.payment_price_cents = this.pad_with_zeroes(this.product_7.payment_price_cents, 2);
        }
        if (isNaN(this.product_7.payment_price_cents)) {
            this.product_7.payment_price_cents = '00';
        }
        this.product_7.payment_x = this.items[6].payment_x;
        this.product_7.code = this.items[6].code;
        this.product_7.feature = this.items[6].features;

        this.product_7.without_entrance = this.items[6].without_entrance;
        this.product_7.without_interest = this.items[6].without_interest;
        this.product_7.in_carne = this.items[6].in_carne;
        this.product_7.in_card = this.items[6].in_card;

        this.product_7.options_buy = '';
        if (this.product_7.without_entrance && this.product_7.without_interest) {
            this.product_7.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_7.without_entrance) this.product_7.options_buy = "Sem Entrada";else if (this.product_7.without_interest) this.product_7.options_buy = "Sem Juros";
        }

        if (this.product_7.without_entrance || this.product_7.without_interest) {
            if (this.product_7.in_carne || this.product_7.in_card) this.product_7.options_buy += " | ";
        }

        if (this.product_7.in_carne && this.product_7.in_card) {
            this.product_7.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_7.in_carne) this.product_7.options_buy += "Carnê";else if (this.product_7.in_card) this.product_7.options_buy += "Cartão";
        }

        this.product_7.options_buy = this.product_7.options_buy.split("|");
        if (this.product_7.options_buy.length > 1) {
            this.product_7.options_buy = this.product_7.options_buy.join("<br>");
        } else {
            this.product_7.options_buy = this.product_7.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 9) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_6: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_7: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_8: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);

        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance) this.product_5.options_buy = "Sem Entrada";else if (this.product_5.without_interest) this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card) this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne) this.product_5.options_buy += "Carnê";else if (this.product_5.in_card) this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }

        // Produto 6

        var txtCompleto6 = sliceWords(this.items[5].name + " ", 30);

        var firstLine6 = sliceWords(txtCompleto6, 18);
        txtCompleto6 = txtCompleto6.replace(firstLine6 + " ", "");
        var secondLine6 = sliceWords(txtCompleto6 + " ", 18);

        var lines6 = [firstLine6, secondLine6];

        this.product_6.name = lines6.join("<br />");
        this.product_6.sight_price = Number(this.items[5].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_6.forward_price = Number(this.items[5].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price6 = String(this.items[5].payment_price).split(".");
        this.product_6.payment_price = Number(payment_price6[0]);
        this.product_6.payment_price_cents = Number(payment_price6[1]);
        if (String(this.product_6.payment_price_cents).length < 2) {
            this.product_6.payment_price_cents = this.pad_with_zeroes(this.product_6.payment_price_cents, 2);
        }
        if (isNaN(this.product_6.payment_price_cents)) {
            this.product_6.payment_price_cents = '00';
        }
        this.product_6.payment_x = this.items[5].payment_x;
        this.product_6.code = this.items[5].code;
        this.product_6.feature = this.items[5].features;

        this.product_6.without_entrance = this.items[5].without_entrance;
        this.product_6.without_interest = this.items[5].without_interest;
        this.product_6.in_carne = this.items[5].in_carne;
        this.product_6.in_card = this.items[5].in_card;

        this.product_6.options_buy = '';
        if (this.product_6.without_entrance && this.product_6.without_interest) {
            this.product_6.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_6.without_entrance) this.product_6.options_buy = "Sem Entrada";else if (this.product_6.without_interest) this.product_6.options_buy = "Sem Juros";
        }

        if (this.product_6.without_entrance || this.product_6.without_interest) {
            if (this.product_6.in_carne || this.product_6.in_card) this.product_6.options_buy += " | ";
        }

        if (this.product_6.in_carne && this.product_6.in_card) {
            this.product_6.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_6.in_carne) this.product_6.options_buy += "Carnê";else if (this.product_6.in_card) this.product_6.options_buy += "Cartão";
        }

        this.product_6.options_buy = this.product_6.options_buy.split("|");
        if (this.product_6.options_buy.length > 1) {
            this.product_6.options_buy = this.product_6.options_buy.join("<br>");
        } else {
            this.product_6.options_buy = this.product_6.options_buy[0];
        }

        // Produto 7

        var txtCompleto7 = sliceWords(this.items[6].name + " ", 30);

        var firstLine7 = sliceWords(txtCompleto7, 18);
        txtCompleto7 = txtCompleto7.replace(firstLine7 + " ", "");
        var secondLine7 = sliceWords(txtCompleto7 + " ", 18);

        var lines7 = [firstLine7, secondLine7];

        this.product_7.name = lines7.join("<br />");
        this.product_7.sight_price = Number(this.items[6].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_7.forward_price = Number(this.items[6].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price7 = String(this.items[6].payment_price).split(".");
        this.product_7.payment_price = Number(payment_price7[0]);
        this.product_7.payment_price_cents = Number(payment_price7[1]);
        if (String(this.product_7.payment_price_cents).length < 2) {
            this.product_7.payment_price_cents = this.pad_with_zeroes(this.product_7.payment_price_cents, 2);
        }
        if (isNaN(this.product_7.payment_price_cents)) {
            this.product_7.payment_price_cents = '00';
        }
        this.product_7.payment_x = this.items[6].payment_x;
        this.product_7.code = this.items[6].code;
        this.product_7.feature = this.items[6].features;

        this.product_7.without_entrance = this.items[6].without_entrance;
        this.product_7.without_interest = this.items[6].without_interest;
        this.product_7.in_carne = this.items[6].in_carne;
        this.product_7.in_card = this.items[6].in_card;

        this.product_7.options_buy = '';
        if (this.product_7.without_entrance && this.product_7.without_interest) {
            this.product_7.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_7.without_entrance) this.product_7.options_buy = "Sem Entrada";else if (this.product_7.without_interest) this.product_7.options_buy = "Sem Juros";
        }

        if (this.product_7.without_entrance || this.product_7.without_interest) {
            if (this.product_7.in_carne || this.product_7.in_card) this.product_7.options_buy += " | ";
        }

        if (this.product_7.in_carne && this.product_7.in_card) {
            this.product_7.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_7.in_carne) this.product_7.options_buy += "Carnê";else if (this.product_7.in_card) this.product_7.options_buy += "Cartão";
        }

        this.product_7.options_buy = this.product_7.options_buy.split("|");
        if (this.product_7.options_buy.length > 1) {
            this.product_7.options_buy = this.product_7.options_buy.join("<br>");
        } else {
            this.product_7.options_buy = this.product_7.options_buy[0];
        }

        // Produto 8

        var txtCompleto8 = sliceWords(this.items[7].name + " ", 30);

        var firstLine8 = sliceWords(txtCompleto8, 18);
        txtCompleto8 = txtCompleto8.replace(firstLine8 + " ", "");
        var secondLine8 = sliceWords(txtCompleto8 + " ", 18);

        var lines8 = [firstLine8, secondLine8];

        this.product_8.name = lines8.join("<br />");
        this.product_8.sight_price = Number(this.items[7].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_8.forward_price = Number(this.items[7].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price8 = String(this.items[7].payment_price).split(".");
        this.product_8.payment_price = Number(payment_price8[0]);
        this.product_8.payment_price_cents = Number(payment_price8[1]);
        if (String(this.product_8.payment_price_cents).length < 2) {
            this.product_8.payment_price_cents = this.pad_with_zeroes(this.product_8.payment_price_cents, 2);
        }
        if (isNaN(this.product_8.payment_price_cents)) {
            this.product_8.payment_price_cents = '00';
        }
        this.product_8.payment_x = this.items[7].payment_x;
        this.product_8.code = this.items[7].code;
        this.product_8.feature = this.items[7].features;

        this.product_8.without_entrance = this.items[7].without_entrance;
        this.product_8.without_interest = this.items[7].without_interest;
        this.product_8.in_carne = this.items[7].in_carne;
        this.product_8.in_card = this.items[7].in_card;

        this.product_8.options_buy = '';
        if (this.product_8.without_entrance && this.product_8.without_interest) {
            this.product_8.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_8.without_entrance) this.product_8.options_buy = "Sem Entrada";else if (this.product_8.without_interest) this.product_8.options_buy = "Sem Juros";
        }

        if (this.product_8.without_entrance || this.product_8.without_interest) {
            if (this.product_8.in_carne || this.product_8.in_card) this.product_8.options_buy += " | ";
        }

        if (this.product_8.in_carne && this.product_8.in_card) {
            this.product_8.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_8.in_carne) this.product_8.options_buy += "Carnê";else if (this.product_8.in_card) this.product_8.options_buy += "Cartão";
        }

        this.product_8.options_buy = this.product_8.options_buy.split("|");
        if (this.product_8.options_buy.length > 1) {
            this.product_8.options_buy = this.product_8.options_buy.join("<br>");
        } else {
            this.product_8.options_buy = this.product_8.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 9) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
    var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    return trimmedString;
}



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "generate2x",
    data: function data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_6: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_7: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_8: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_9: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            }
        };
    },
    created: function created() {
        var body = document.body;
        var className = "body";
        if (body.classList) body.classList.add(className);else body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList) html.classList.add(className);else html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        var linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        var chamada_total = this.$route.params.chamada;
        var linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList) body.classList.add(classNameBody);else body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function () {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList) chamada.classList.add(classNameChamada);else chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);

        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance) this.product_1.options_buy = "Sem Entrada";else if (this.product_1.without_interest) this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card) this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne) this.product_1.options_buy += "Carnê";else if (this.product_1.in_card) this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance) this.product_2.options_buy = "Sem Entrada";else if (this.product_2.without_interest) this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card) this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne) this.product_2.options_buy += "Carnê";else if (this.product_2.in_card) this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);

        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance) this.product_3.options_buy = "Sem Entrada";else if (this.product_3.without_interest) this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card) this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne) this.product_3.options_buy += "Carnê";else if (this.product_3.in_card) this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);

        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance) this.product_4.options_buy = "Sem Entrada";else if (this.product_4.without_interest) this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card) this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne) this.product_4.options_buy += "Carnê";else if (this.product_4.in_card) this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);

        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance) this.product_5.options_buy = "Sem Entrada";else if (this.product_5.without_interest) this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card) this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne) this.product_5.options_buy += "Carnê";else if (this.product_5.in_card) this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }

        // Produto 6

        var txtCompleto6 = sliceWords(this.items[5].name + " ", 30);

        var firstLine6 = sliceWords(txtCompleto6, 18);
        txtCompleto6 = txtCompleto6.replace(firstLine6 + " ", "");
        var secondLine6 = sliceWords(txtCompleto6 + " ", 18);

        var lines6 = [firstLine6, secondLine6];

        this.product_6.name = lines6.join("<br />");
        this.product_6.sight_price = Number(this.items[5].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_6.forward_price = Number(this.items[5].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price6 = String(this.items[5].payment_price).split(".");
        this.product_6.payment_price = Number(payment_price6[0]);
        this.product_6.payment_price_cents = Number(payment_price6[1]);
        if (String(this.product_6.payment_price_cents).length < 2) {
            this.product_6.payment_price_cents = this.pad_with_zeroes(this.product_6.payment_price_cents, 2);
        }
        if (isNaN(this.product_6.payment_price_cents)) {
            this.product_6.payment_price_cents = '00';
        }
        this.product_6.payment_x = this.items[5].payment_x;
        this.product_6.code = this.items[5].code;
        this.product_6.feature = this.items[5].features;

        this.product_6.without_entrance = this.items[5].without_entrance;
        this.product_6.without_interest = this.items[5].without_interest;
        this.product_6.in_carne = this.items[5].in_carne;
        this.product_6.in_card = this.items[5].in_card;

        this.product_6.options_buy = '';
        if (this.product_6.without_entrance && this.product_6.without_interest) {
            this.product_6.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_6.without_entrance) this.product_6.options_buy = "Sem Entrada";else if (this.product_6.without_interest) this.product_6.options_buy = "Sem Juros";
        }

        if (this.product_6.without_entrance || this.product_6.without_interest) {
            if (this.product_6.in_carne || this.product_6.in_card) this.product_6.options_buy += " | ";
        }

        if (this.product_6.in_carne && this.product_6.in_card) {
            this.product_6.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_6.in_carne) this.product_6.options_buy += "Carnê";else if (this.product_6.in_card) this.product_6.options_buy += "Cartão";
        }

        this.product_6.options_buy = this.product_6.options_buy.split("|");
        if (this.product_6.options_buy.length > 1) {
            this.product_6.options_buy = this.product_6.options_buy.join("<br>");
        } else {
            this.product_6.options_buy = this.product_6.options_buy[0];
        }

        // Produto 7

        var txtCompleto7 = sliceWords(this.items[6].name + " ", 30);

        var firstLine7 = sliceWords(txtCompleto7, 18);
        txtCompleto7 = txtCompleto7.replace(firstLine7 + " ", "");
        var secondLine7 = sliceWords(txtCompleto7 + " ", 18);

        var lines7 = [firstLine7, secondLine7];

        this.product_7.name = lines7.join("<br />");
        this.product_7.sight_price = Number(this.items[6].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_7.forward_price = Number(this.items[6].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price7 = String(this.items[6].payment_price).split(".");
        this.product_7.payment_price = Number(payment_price7[0]);
        this.product_7.payment_price_cents = Number(payment_price7[1]);
        if (String(this.product_7.payment_price_cents).length < 2) {
            this.product_7.payment_price_cents = this.pad_with_zeroes(this.product_7.payment_price_cents, 2);
        }
        if (isNaN(this.product_7.payment_price_cents)) {
            this.product_7.payment_price_cents = '00';
        }
        this.product_7.payment_x = this.items[6].payment_x;
        this.product_7.code = this.items[6].code;
        this.product_7.feature = this.items[6].features;

        this.product_7.without_entrance = this.items[6].without_entrance;
        this.product_7.without_interest = this.items[6].without_interest;
        this.product_7.in_carne = this.items[6].in_carne;
        this.product_7.in_card = this.items[6].in_card;

        this.product_7.options_buy = '';
        if (this.product_7.without_entrance && this.product_7.without_interest) {
            this.product_7.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_7.without_entrance) this.product_7.options_buy = "Sem Entrada";else if (this.product_7.without_interest) this.product_7.options_buy = "Sem Juros";
        }

        if (this.product_7.without_entrance || this.product_7.without_interest) {
            if (this.product_7.in_carne || this.product_7.in_card) this.product_7.options_buy += " | ";
        }

        if (this.product_7.in_carne && this.product_7.in_card) {
            this.product_7.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_7.in_carne) this.product_7.options_buy += "Carnê";else if (this.product_7.in_card) this.product_7.options_buy += "Cartão";
        }

        this.product_7.options_buy = this.product_7.options_buy.split("|");
        if (this.product_7.options_buy.length > 1) {
            this.product_7.options_buy = this.product_7.options_buy.join("<br>");
        } else {
            this.product_7.options_buy = this.product_7.options_buy[0];
        }

        // Produto 8

        var txtCompleto8 = sliceWords(this.items[7].name + " ", 30);

        var firstLine8 = sliceWords(txtCompleto8, 18);
        txtCompleto8 = txtCompleto8.replace(firstLine8 + " ", "");
        var secondLine8 = sliceWords(txtCompleto8 + " ", 18);

        var lines8 = [firstLine8, secondLine8];

        this.product_8.name = lines8.join("<br />");
        this.product_8.sight_price = Number(this.items[7].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_8.forward_price = Number(this.items[7].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price8 = String(this.items[7].payment_price).split(".");
        this.product_8.payment_price = Number(payment_price8[0]);
        this.product_8.payment_price_cents = Number(payment_price8[1]);
        if (String(this.product_8.payment_price_cents).length < 2) {
            this.product_8.payment_price_cents = this.pad_with_zeroes(this.product_8.payment_price_cents, 2);
        }
        if (isNaN(this.product_8.payment_price_cents)) {
            this.product_8.payment_price_cents = '00';
        }
        this.product_8.payment_x = this.items[7].payment_x;
        this.product_8.code = this.items[7].code;
        this.product_8.feature = this.items[7].features;

        this.product_8.without_entrance = this.items[7].without_entrance;
        this.product_8.without_interest = this.items[7].without_interest;
        this.product_8.in_carne = this.items[7].in_carne;
        this.product_8.in_card = this.items[7].in_card;

        this.product_8.options_buy = '';
        if (this.product_8.without_entrance && this.product_8.without_interest) {
            this.product_8.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_8.without_entrance) this.product_8.options_buy = "Sem Entrada";else if (this.product_8.without_interest) this.product_8.options_buy = "Sem Juros";
        }

        if (this.product_8.without_entrance || this.product_8.without_interest) {
            if (this.product_8.in_carne || this.product_8.in_card) this.product_8.options_buy += " | ";
        }

        if (this.product_8.in_carne && this.product_8.in_card) {
            this.product_8.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_8.in_carne) this.product_8.options_buy += "Carnê";else if (this.product_8.in_card) this.product_8.options_buy += "Cartão";
        }

        this.product_8.options_buy = this.product_8.options_buy.split("|");
        if (this.product_8.options_buy.length > 1) {
            this.product_8.options_buy = this.product_8.options_buy.join("<br>");
        } else {
            this.product_8.options_buy = this.product_8.options_buy[0];
        }

        // Produto 9

        var txtCompleto9 = sliceWords(this.items[8].name + " ", 30);

        var firstLine9 = sliceWords(txtCompleto9, 18);
        txtCompleto9 = txtCompleto9.replace(firstLine9 + " ", "");
        var secondLine9 = sliceWords(txtCompleto9 + " ", 18);

        var lines9 = [firstLine9, secondLine9];

        this.product_9.name = lines9.join("<br />");
        this.product_9.sight_price = Number(this.items[8].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        this.product_9.forward_price = Number(this.items[8].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        var payment_price9 = String(this.items[8].payment_price).split(".");
        this.product_9.payment_price = Number(payment_price9[0]);
        this.product_9.payment_price_cents = Number(payment_price9[1]);
        if (String(this.product_9.payment_price_cents).length < 2) {
            this.product_9.payment_price_cents = this.pad_with_zeroes(this.product_9.payment_price_cents, 2);
        }
        if (isNaN(this.product_9.payment_price_cents)) {
            this.product_9.payment_price_cents = '00';
        }
        this.product_9.payment_x = this.items[8].payment_x;
        this.product_9.code = this.items[8].code;
        this.product_9.feature = this.items[8].features;

        this.product_9.without_entrance = this.items[8].without_entrance;
        this.product_9.without_interest = this.items[8].without_interest;
        this.product_9.in_carne = this.items[8].in_carne;
        this.product_9.in_card = this.items[8].in_card;

        this.product_9.options_buy = '';
        if (this.product_9.without_entrance && this.product_9.without_interest) {
            this.product_9.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_9.without_entrance) this.product_9.options_buy = "Sem Entrada";else if (this.product_9.without_interest) this.product_9.options_buy = "Sem Juros";
        }

        if (this.product_9.without_entrance || this.product_9.without_interest) {
            if (this.product_9.in_carne || this.product_9.in_card) this.product_9.options_buy += " | ";
        }

        if (this.product_9.in_carne && this.product_9.in_card) {
            this.product_9.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_9.in_carne) this.product_9.options_buy += "Carnê";else if (this.product_9.in_card) this.product_9.options_buy += "Cartão";
        }

        this.product_9.options_buy = this.product_9.options_buy.split("|");
        if (this.product_9.options_buy.length > 1) {
            this.product_9.options_buy = this.product_9.options_buy.join("<br>");
        } else {
            this.product_9.options_buy = this.product_9.options_buy[0];
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_0__config_js__["b" /* SYSTEM_ENV */] === 1) {
            var interval = setInterval(function () {
                if (_this.allLoaded === 10) {
                    clearInterval(interval);

                    window.scrollTo(0, 0);

                    var self = _this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false
                    }).then(function (canvas) {
                        self.showHTML = false;

                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.body, "tema-2");
                        _this.removeClass(document.body, "tema-3");
                        _this.removeClass(document.body, "tema-4");
                        _this.removeClass(document.body, "tema-5");
                        _this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        var token = localStorage.getItem("user-token");
                        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* BASE_URL_API */] + '/save-image', { token: token, image: img }).then(function (response) {
                            response.json().then(function (json) {
                                // window.open(json.url);
                                _this.url = json.url;
                            });
                        }, function (response) {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.');
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        _this.removeClass(document.body, "body");
                        _this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed: function destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },

    methods: {
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad: function incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes: function pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico: function mounta_juridico() {
            var valid = "Oferta v\xE1lida de " + this.formatDate(this.dtinicio) + " at\xE9 " + this.formatDate(this.dtfim) + " ou enquanto durar o estoque.";
            var to = "Para";
            var c = 0;
            this.abrangencia.forEach(function (el, ind) {
                to += (c === 0 ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            var complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate: function formatDate(dt) {
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(57);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);



var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    base: "/",
    routes: __WEBPACK_IMPORTED_MODULE_6__routes__["a" /* routes */],
    mode: "history"
});

router.beforeEach(function (to, from, next) {
    var token = localStorage.getItem("user-token");
    var user_mix = localStorage.getItem("user-mix");

    if (to.path === "/faz-login-mix") {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* BASE_URL_API */] + '/auth/login', {
            email: 'ybogisich@douglas.com',
            password: '12345'
        }).then(function (response) {
            response.json().then(function (json) {
                window.localStorage.setItem('user-token', json.token);

                window.localStorage.setItem('user-mix', 'y');

                next("/");
            });
        }, function (response) {
            // error callback
            alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.');
        });
    }

    if (!token) {
        if (!user_mix) {
            if (to.path !== "/login") {
                next("/login");
                return;
            }
        } else {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* BASE_URL_API */] + '/auth/login', {
                email: 'ybogisich@douglas.com',
                password: '12345'
            }).then(function (response) {
                response.json().then(function (json) {
                    window.localStorage.setItem('user-token', json.token);

                    window.localStorage.setItem('user-mix', 'y');

                    next("/");
                });
            }, function (response) {
                // error callback
                alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.');
            });
        }
    } else {
        // if (to.path === "/login") {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* BASE_URL_API */] + "/status-token", { params: { token: token } }).then(function (res) {
            return res.json();
        }).then(function (json) {}, function (json) {
            console.log(json);
            if (json.error === "ok") {
                // next("/");
                // return;
            } else {
                if (user_mix) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* BASE_URL_API */] + '/auth/login', {
                        email: 'ybogisich@douglas.com',
                        password: '12345'
                    }).then(function (response) {
                        response.json().then(function (json) {
                            window.localStorage.setItem('user-token', json.token);

                            window.localStorage.setItem('user-mix', 'y');

                            next("/");
                        });
                    }, function (response) {
                        // error callback
                        alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.');
                    });
                } else {
                    next("/login");
                    return;
                }
            }
        });
        // }
    }

    next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive("resize-image", {
    inserted: function inserted(el, binding, vnode) {
        // alert("ola");
        console.log(el);
        el.getElementsByTagName("img")[0].addEventListener("load", function () {
            var maxWidth = el.clientWidth; // Max width for the image
            var maxHeight = el.clientHeight; // Max height for the image
            var ratio = 0; // Used for aspect ratio
            var width = el.getElementsByTagName("img")[0].clientWidth; // Current image width
            var height = el.getElementsByTagName("img")[0].clientHeight; // Current image height

            var sizes = {
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                width: width,
                height: height
            };

            console.log(sizes);

            // Check if the current width is larger than the max
            if (width > maxWidth) {
                ratio = maxWidth / width; // get ratio for scaling image
                el.getElementsByTagName("img")[0].style.width = maxWidth + "px"; // Set new width
                el.getElementsByTagName("img")[0].style.height = height * ratio + "px"; // Scale height based on ratio
                // $("img").css("width", maxWidth); // Set new width
                // $("img").css("height", height * ratio);  // Scale height based on ratio
                height = height * ratio; // Reset height to match scaled image
                width = width * ratio; // Reset width to match scaled image
            }

            // Check if current height is larger than max
            if (height > maxHeight) {
                ratio = maxHeight / height; // get ratio for scaling image
                el.getElementsByTagName("img")[0].style.height = maxHeight + "px"; // Set new height
                el.getElementsByTagName("img")[0].style.width = width * ratio + "px"; // Scale width based on ratio
                // $("img").css("height", maxHeight);   // Set new height
                // $("img").css("width", width * ratio);    // Scale width based on ratio
                width = width * ratio; // Reset width to match scaled image
                height = height * ratio; // Reset height to match scaled image
            }
        });
    }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: "#app",
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15), __webpack_require__(42).setImmediate))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(43);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(44)))

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17ea2a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17ea2a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1aec229d", content, true, {});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".pages-enter,.pages-leave-active{opacity:0}.pages-enter-active,.pages-leave-active{transition:opacity .3s}", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"pages"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.1.3
  * (c) 2019 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isExtendedError (constructor, err) {
  return (
    err instanceof constructor ||
    // _name is to support IE9 too
    (err && (err.name === constructor.name || err._name === constructor._name))
  )
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode && parent.$vnode.data;
      if (vnodeData) {
        if (vnodeData.routerView) {
          depth++;
        }
        if (vnodeData.keepAlive && parent._inactive) {
          inactive = true;
        }
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    return extend({}, raw)
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.props.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && 'pushState' in window.history
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: getStateKey() }, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

var NavigationDuplicated = /*@__PURE__*/(function (Error) {
  function NavigationDuplicated (normalizedLocation) {
    Error.call(this);
    this.name = this._name = 'NavigationDuplicated';
    // passing the message to super() doesn't seem to work in the transpiled version
    this.message = "Navigating to current location (\"" + (normalizedLocation.fullPath) + "\") is not allowed";
    // add a stack property so services like Sentry can correctly display it
    Object.defineProperty(this, 'stack', {
      value: new Error().stack,
      writable: true,
      configurable: true
    });
    // we could also have used
    // Error.captureStackTrace(this, this.constructor)
    // but it only exists on node and chrome
  }

  if ( Error ) NavigationDuplicated.__proto__ = Error;
  NavigationDuplicated.prototype = Object.create( Error && Error.prototype );
  NavigationDuplicated.prototype.constructor = NavigationDuplicated;

  return NavigationDuplicated;
}(Error));

// support IE9
NavigationDuplicated._name = 'NavigationDuplicated';

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    // after merging https://github.com/vuejs/vue-router/pull/2771 we
    // When the user navigates through history through back/forward buttons
    // we do not want to throw the error. We only throw it if directly calling
    // push/replace. That's why it's not included in isError
    if (!isExtendedError(NavigationDuplicated, err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort(new NavigationDuplicated(route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    var this$1 = this;

    History.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(
      supportsPushState ? 'popstate' : 'hashchange',
      function () {
        var current = this$1.current;
        if (!ensureSlash()) {
          return
        }
        this$1.transitionTo(getHash(), function (route) {
          if (supportsScroll) {
            handleScroll(this$1.router, route, current, true);
          }
          if (!supportsPushState) {
            replaceHash(route.fullPath);
          }
        });
      }
    );
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    if (searchIndex > -1) {
      href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
    }
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        this$1.index = targetIndex;
        this$1.updateRoute(route);
      },
      function (err) {
        if (isExtendedError(NavigationDuplicated, err)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.1.3';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(52);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 52 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_min_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_min_css__);
// @ts-check
/** @type swal {import("sweetalert2")} */



function isBrowser() {
    return typeof window !== 'undefined';
}

var VueSweetalert2 = function () {};


VueSweetalert2.install = function (Vue, options) {
    // adding a global method or property
    var _swal;

    if (isBrowser()) {
        _swal = (options ? __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_min_js___default.a.mixin(options) : __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_min_js___default.a);
    } else {
        _swal = function () {
            return Promise.resolve();
        };
    }

    Vue.swal = _swal;

    // add the instance method
    if (!Vue.prototype.hasOwnProperty('$swal')) {
        Object.defineProperty(Vue.prototype, '$swal', {
            get: function get() {
                return _swal
            }
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (VueSweetalert2);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Sweetalert2=t()}(this,function(){"use strict";function q(e){return(q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function i(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),e}function r(){return(r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e}).apply(this,arguments)}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t)}function c(e){return(c=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e,t){return(u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function l(e,t,n){return(l=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(e){return!1}}()?Reflect.construct:function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&u(i,n.prototype),i}).apply(null,arguments)}function d(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function p(e,t,n){return(p="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,n){var o=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=c(e)););return e}(e,t);if(o){var i=Object.getOwnPropertyDescriptor(o,t);return i.get?i.get.call(n):i.value}})(e,t,n||e)}var t="SweetAlert2:",f=function(e){return Array.prototype.slice.call(e)},R=function(e){console.warn("".concat(t," ").concat(e))},I=function(e){console.error("".concat(t," ").concat(e))},n=[],m=function(e){-1===n.indexOf(e)&&(n.push(e),R(e))},H=function(e){return"function"==typeof e?e():e},D=function(e){return e&&Promise.resolve(e)===e},e=Object.freeze({cancel:"cancel",backdrop:"overlay",close:"close",esc:"esc",timer:"timer"}),h=function(e){var t={};for(var n in e)t[e[n]]="swal2-"+e[n];return t},_=h(["container","shown","height-auto","iosfix","popup","modal","no-backdrop","toast","toast-shown","toast-column","fade","show","hide","noanimation","close","title","header","content","actions","confirm","cancel","footer","icon","icon-text","image","input","file","range","select","radio","checkbox","label","textarea","inputerror","validation-message","progresssteps","activeprogressstep","progresscircle","progressline","loading","styled","top","top-start","top-end","top-left","top-right","center","center-start","center-end","center-left","center-right","bottom","bottom-start","bottom-end","bottom-left","bottom-right","grow-row","grow-column","grow-fullscreen","rtl"]),g=h(["success","warning","info","question","error"]),b={previousBodyPadding:null},v=function(e,t){return e.classList.contains(t)},N=function(e){if(e.focus(),"file"!==e.type){var t=e.value;e.value="",e.value=t}},y=function(e,t,n){e&&t&&("string"==typeof t&&(t=t.split(/\s+/).filter(Boolean)),t.forEach(function(t){e.forEach?e.forEach(function(e){n?e.classList.add(t):e.classList.remove(t)}):n?e.classList.add(t):e.classList.remove(t)}))},z=function(e,t){y(e,t,!0)},W=function(e,t){y(e,t,!1)},U=function(e,t){for(var n=0;n<e.childNodes.length;n++)if(v(e.childNodes[n],t))return e.childNodes[n]},K=function(e){e.style.opacity="",e.style.display=e.id===_.content?"block":"flex"},F=function(e){e.style.opacity="",e.style.display="none"},Z=function(e){return e&&(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},w=function(){return document.body.querySelector("."+_.container)},C=function(e){var t=w();return t?t.querySelector("."+e):null},k=function(){return C(_.popup)},x=function(){var e=k();return f(e.querySelectorAll("."+_.icon))},A=function(){return C(_.title)},B=function(){return C(_.content)},S=function(){return C(_.image)},P=function(){return C(_.progresssteps)},E=function(){return C(_["validation-message"])},L=function(){return C(_.confirm)},O=function(){return C(_.cancel)},Q=function(){return C(_.actions)},Y=function(){return C(_.footer)},$=function(){return C(_.close)},J=function(){var e=f(k().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')).sort(function(e,t){return e=parseInt(e.getAttribute("tabindex")),(t=parseInt(t.getAttribute("tabindex")))<e?1:e<t?-1:0}),t=f(k().querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls]')).filter(function(e){return"-1"!==e.getAttribute("tabindex")});return function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(e.concat(t)).filter(function(e){return Z(e)})},T=function(){return!M()&&!document.body.classList.contains(_["no-backdrop"])},M=function(){return document.body.classList.contains(_["toast-shown"])},j=function(){return"undefined"==typeof window||"undefined"==typeof document},V='\n <div aria-labelledby="'.concat(_.title,'" aria-describedby="').concat(_.content,'" class="').concat(_.popup,'" tabindex="-1">\n   <div class="').concat(_.header,'">\n     <ul class="').concat(_.progresssteps,'"></ul>\n     <div class="').concat(_.icon," ").concat(g.error,'">\n       <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n     </div>\n     <div class="').concat(_.icon," ").concat(g.question,'">\n       <span class="').concat(_["icon-text"],'">?</span>\n      </div>\n     <div class="').concat(_.icon," ").concat(g.warning,'">\n       <span class="').concat(_["icon-text"],'">!</span>\n      </div>\n     <div class="').concat(_.icon," ").concat(g.info,'">\n       <span class="').concat(_["icon-text"],'">i</span>\n      </div>\n     <div class="').concat(_.icon," ").concat(g.success,'">\n       <div class="swal2-success-circular-line-left"></div>\n       <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n       <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n       <div class="swal2-success-circular-line-right"></div>\n     </div>\n     <img class="').concat(_.image,'" />\n     <h2 class="').concat(_.title,'" id="').concat(_.title,'"></h2>\n     <button type="button" class="').concat(_.close,'">×</button>\n   </div>\n   <div class="').concat(_.content,'">\n     <div id="').concat(_.content,'"></div>\n     <input class="').concat(_.input,'" />\n     <input type="file" class="').concat(_.file,'" />\n     <div class="').concat(_.range,'">\n       <input type="range" />\n       <output></output>\n     </div>\n     <select class="').concat(_.select,'"></select>\n     <div class="').concat(_.radio,'"></div>\n     <label for="').concat(_.checkbox,'" class="').concat(_.checkbox,'">\n       <input type="checkbox" />\n       <span class="').concat(_.label,'"></span>\n     </label>\n     <textarea class="').concat(_.textarea,'"></textarea>\n     <div class="').concat(_["validation-message"],'" id="').concat(_["validation-message"],'"></div>\n   </div>\n   <div class="').concat(_.actions,'">\n     <button type="button" class="').concat(_.confirm,'">OK</button>\n     <button type="button" class="').concat(_.cancel,'">Cancel</button>\n   </div>\n   <div class="').concat(_.footer,'">\n   </div>\n </div>\n').replace(/(^|\n)\s*/g,""),X=function(e){var t=w();if(t&&(t.parentNode.removeChild(t),W([document.documentElement,document.body],[_["no-backdrop"],_["toast-shown"],_["has-column"]])),!j()){var n=document.createElement("div");n.className=_.container,n.innerHTML=V;var o="string"==typeof e.target?document.querySelector(e.target):e.target;o.appendChild(n);var i,r=k(),a=B(),s=U(a,_.input),c=U(a,_.file),u=a.querySelector(".".concat(_.range," input")),l=a.querySelector(".".concat(_.range," output")),d=U(a,_.select),p=a.querySelector(".".concat(_.checkbox," input")),f=U(a,_.textarea);r.setAttribute("role",e.toast?"alert":"dialog"),r.setAttribute("aria-live",e.toast?"polite":"assertive"),e.toast||r.setAttribute("aria-modal","true"),"rtl"===window.getComputedStyle(o).direction&&z(w(),_.rtl);var m=function(e){De.isVisible()&&i!==e.target.value&&De.resetValidationMessage(),i=e.target.value};return s.oninput=m,c.onchange=m,d.onchange=m,p.onchange=m,f.oninput=m,u.oninput=function(e){m(e),l.value=u.value},u.onchange=function(e){m(e),u.nextSibling.value=u.value},r}I("SweetAlert2 requires document to initialize")},G=function(e,t){if(!e)return F(t);if(e instanceof HTMLElement)t.appendChild(e);else if("object"===q(e))if(t.innerHTML="",0 in e)for(var n=0;n in e;n++)t.appendChild(e[n].cloneNode(!0));else t.appendChild(e.cloneNode(!0));else e&&(t.innerHTML=e);K(t)},ee=function(){if(j())return!1;var e=document.createElement("div"),t={WebkitAnimation:"webkitAnimationEnd",OAnimation:"oAnimationEnd oanimationend",animation:"animationend"};for(var n in t)if(t.hasOwnProperty(n)&&void 0!==e.style[n])return t[n];return!1}(),te=function(e){var t=Q(),n=L(),o=O();if(e.showConfirmButton||e.showCancelButton?K(t):F(t),e.showCancelButton?o.style.display="inline-block":F(o),e.showConfirmButton?n.style.removeProperty("display"):F(n),n.innerHTML=e.confirmButtonText,o.innerHTML=e.cancelButtonText,n.setAttribute("aria-label",e.confirmButtonAriaLabel),o.setAttribute("aria-label",e.cancelButtonAriaLabel),n.className=_.confirm,z(n,e.confirmButtonClass),o.className=_.cancel,z(o,e.cancelButtonClass),e.buttonsStyling){z([n,o],_.styled),e.confirmButtonColor&&(n.style.backgroundColor=e.confirmButtonColor),e.cancelButtonColor&&(o.style.backgroundColor=e.cancelButtonColor);var i=window.getComputedStyle(n).getPropertyValue("background-color");n.style.borderLeftColor=i,n.style.borderRightColor=i}else W([n,o],_.styled),n.style.backgroundColor=n.style.borderLeftColor=n.style.borderRightColor="",o.style.backgroundColor=o.style.borderLeftColor=o.style.borderRightColor=""},ne=function(e){var t=B().querySelector("#"+_.content);e.html?G(e.html,t):e.text?(t.textContent=e.text,K(t)):F(t)},oe=function(e){for(var t=x(),n=0;n<t.length;n++)F(t[n]);if(e.type)if(-1!==Object.keys(g).indexOf(e.type)){var o=De.getPopup().querySelector(".".concat(_.icon,".").concat(g[e.type]));K(o),e.animation&&z(o,"swal2-animate-".concat(e.type,"-icon"))}else I('Unknown type! Expected "success", "error", "warning", "info" or "question", got "'.concat(e.type,'"'))},ie=function(e){var t=S();e.imageUrl?(t.setAttribute("src",e.imageUrl),t.setAttribute("alt",e.imageAlt),K(t),e.imageWidth?t.setAttribute("width",e.imageWidth):t.removeAttribute("width"),e.imageHeight?t.setAttribute("height",e.imageHeight):t.removeAttribute("height"),t.className=_.image,e.imageClass&&z(t,e.imageClass)):F(t)},re=function(i){var r=P(),a=parseInt(null===i.currentProgressStep?De.getQueueStep():i.currentProgressStep,10);i.progressSteps&&i.progressSteps.length?(K(r),r.innerHTML="",a>=i.progressSteps.length&&R("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"),i.progressSteps.forEach(function(e,t){var n=document.createElement("li");if(z(n,_.progresscircle),n.innerHTML=e,t===a&&z(n,_.activeprogressstep),r.appendChild(n),t!==i.progressSteps.length-1){var o=document.createElement("li");z(o,_.progressline),i.progressStepsDistance&&(o.style.width=i.progressStepsDistance),r.appendChild(o)}})):F(r)},ae=function(e){var t=A();e.titleText?t.innerText=e.titleText:e.title&&("string"==typeof e.title&&(e.title=e.title.split("\n").join("<br />")),G(e.title,t))},se=function(){null===b.previousBodyPadding&&document.body.scrollHeight>window.innerHeight&&(b.previousBodyPadding=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")),document.body.style.paddingRight=b.previousBodyPadding+function(){if("ontouchstart"in window||navigator.msMaxTouchPoints)return 0;var e=document.createElement("div");e.style.width="50px",e.style.height="50px",e.style.overflow="scroll",document.body.appendChild(e);var t=e.offsetWidth-e.clientWidth;return document.body.removeChild(e),t}()+"px")},ce=function(){return!!window.MSInputMethodContext&&!!document.documentMode},ue=function(){var e=w(),t=k();e.style.removeProperty("align-items"),t.offsetTop<0&&(e.style.alignItems="flex-start")},le={},de=function(e,t){var n=w(),o=k();if(o){null!==e&&"function"==typeof e&&e(o),W(o,_.show),z(o,_.hide);var i=function(){M()?pe(t):(new Promise(function(e){var t=window.scrollX,n=window.scrollY;le.restoreFocusTimeout=setTimeout(function(){le.previousActiveElement&&le.previousActiveElement.focus?(le.previousActiveElement.focus(),le.previousActiveElement=null):document.body&&document.body.focus(),e()},100),void 0!==t&&void 0!==n&&window.scrollTo(t,n)}).then(function(){return pe(t)}),le.keydownTarget.removeEventListener("keydown",le.keydownHandler,{capture:le.keydownListenerCapture}),le.keydownHandlerAdded=!1),n.parentNode&&n.parentNode.removeChild(n),W([document.documentElement,document.body],[_.shown,_["height-auto"],_["no-backdrop"],_["toast-shown"],_["toast-column"]]),T()&&(null!==b.previousBodyPadding&&(document.body.style.paddingRight=b.previousBodyPadding,b.previousBodyPadding=null),function(){if(v(document.body,_.iosfix)){var e=parseInt(document.body.style.top,10);W(document.body,_.iosfix),document.body.style.top="",document.body.scrollTop=-1*e}}(),"undefined"!=typeof window&&ce()&&window.removeEventListener("resize",ue),f(document.body.children).forEach(function(e){e.hasAttribute("data-previous-aria-hidden")?(e.setAttribute("aria-hidden",e.getAttribute("data-previous-aria-hidden")),e.removeAttribute("data-previous-aria-hidden")):e.removeAttribute("aria-hidden")}))};ee&&!v(o,_.noanimation)?o.addEventListener(ee,function e(){o.removeEventListener(ee,e),v(o,_.hide)&&i()}):i()}},pe=function(e){null!==e&&"function"==typeof e&&setTimeout(function(){e()})};function fe(e){var t=function e(){for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];if(!(this instanceof e))return l(e,n);Object.getPrototypeOf(e).apply(this,n)};return t.prototype=r(Object.create(e.prototype),{constructor:t}),"function"==typeof Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e,t}var me={title:"",titleText:"",text:"",html:"",footer:"",type:null,toast:!1,customClass:"",customContainerClass:"",target:"body",backdrop:!0,animation:!0,heightAuto:!0,allowOutsideClick:!0,allowEscapeKey:!0,allowEnterKey:!0,stopKeydownPropagation:!0,keydownListenerCapture:!1,showConfirmButton:!0,showCancelButton:!1,preConfirm:null,confirmButtonText:"OK",confirmButtonAriaLabel:"",confirmButtonColor:null,confirmButtonClass:null,cancelButtonText:"Cancel",cancelButtonAriaLabel:"",cancelButtonColor:null,cancelButtonClass:null,buttonsStyling:!0,reverseButtons:!1,focusConfirm:!0,focusCancel:!1,showCloseButton:!1,closeButtonAriaLabel:"Close this dialog",showLoaderOnConfirm:!1,imageUrl:null,imageWidth:null,imageHeight:null,imageAlt:"",imageClass:null,timer:null,width:null,padding:null,background:null,input:null,inputPlaceholder:"",inputValue:"",inputOptions:{},inputAutoTrim:!0,inputClass:null,inputAttributes:{},inputValidator:null,validationMessage:null,grow:!1,position:"center",progressSteps:[],currentProgressStep:null,progressStepsDistance:null,onBeforeOpen:null,onAfterClose:null,onOpen:null,onClose:null,useRejections:!1,expectRejections:!1},he=["useRejections","expectRejections","extraParams"],ge=["allowOutsideClick","allowEnterKey","backdrop","focusConfirm","focusCancel","heightAuto","keydownListenerCapture"],be=function(e){return me.hasOwnProperty(e)||"extraParams"===e},ve=function(e){return-1!==he.indexOf(e)},ye=function(e){for(var t in e)be(t)||R('Unknown parameter "'.concat(t,'"')),e.toast&&-1!==ge.indexOf(t)&&R('The parameter "'.concat(t,'" is incompatible with toasts')),ve(t)&&m('The parameter "'.concat(t,'" is deprecated and will be removed in the next major release.'))},we='"setDefaults" & "resetDefaults" methods are deprecated in favor of "mixin" method and will be removed in the next major release. For new projects, use "mixin". For past projects already using "setDefaults", support will be provided through an additional package.',Ce={};var ke=[],xe=function(){var e=k();e||De(""),e=k();var t=Q(),n=L(),o=O();K(t),K(n),z([e,t],_.loading),n.disabled=!0,o.disabled=!0,e.setAttribute("data-loading",!0),e.setAttribute("aria-busy",!0),e.focus()},Ae=Object.freeze({isValidParameter:be,isDeprecatedParameter:ve,argsToParams:function(n){var o={};switch(q(n[0])){case"object":r(o,n[0]);break;default:["title","html","type"].forEach(function(e,t){switch(q(n[t])){case"string":o[e]=n[t];break;case"undefined":break;default:I("Unexpected type of ".concat(e,'! Expected "string", got ').concat(q(n[t])))}})}return o},adaptInputValidator:function(n){return function(e,t){return n.call(this,e,t).then(function(){},function(e){return e})}},close:de,closePopup:de,closeModal:de,closeToast:de,isVisible:function(){return!!k()},clickConfirm:function(){return L().click()},clickCancel:function(){return O().click()},getContainer:w,getPopup:k,getTitle:A,getContent:B,getImage:S,getIcons:x,getCloseButton:$,getButtonsWrapper:function(){return m("swal.getButtonsWrapper() is deprecated and will be removed in the next major release, use swal.getActions() instead"),C(_.actions)},getActions:Q,getConfirmButton:L,getCancelButton:O,getFooter:Y,getFocusableElements:J,getValidationMessage:E,isLoading:function(){return k().hasAttribute("data-loading")},fire:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return l(this,t)},mixin:function(n){return fe(function(e){function t(){return a(this,t),d(this,c(t).apply(this,arguments))}return s(t,e),i(t,[{key:"_main",value:function(e){return p(c(t.prototype),"_main",this).call(this,r({},n,e))}}]),t}(this))},queue:function(e){var r=this;ke=e;var a=function(){ke=[],document.body.removeAttribute("data-swal2-queue-step")},s=[];return new Promise(function(i){!function t(n,o){n<ke.length?(document.body.setAttribute("data-swal2-queue-step",n),r(ke[n]).then(function(e){void 0!==e.value?(s.push(e.value),t(n+1,o)):(a(),i({dismiss:e.dismiss}))})):(a(),i({value:s}))}(0)})},getQueueStep:function(){return document.body.getAttribute("data-swal2-queue-step")},insertQueueStep:function(e,t){return t&&t<ke.length?ke.splice(t,0,e):ke.push(e)},deleteQueueStep:function(e){void 0!==ke[e]&&ke.splice(e,1)},showLoading:xe,enableLoading:xe,getTimerLeft:function(){return le.timeout&&le.timeout.getTimerLeft()},stopTimer:function(){return le.timeout&&le.timeout.stop()},resumeTimer:function(){return le.timeout&&le.timeout.start()},toggleTimer:function(){var e=le.timeout;return e&&(e.running?e.stop():e.start())},increaseTimer:function(e){return le.timeout&&le.timeout.increase(e)},isTimerRunning:function(){return le.timeout&&le.timeout.isRunning()}}),Be="function"==typeof Symbol?Symbol:function(){var t=0;function e(e){return"__"+e+"_"+Math.floor(1e9*Math.random())+"_"+ ++t+"__"}return e.iterator=e("Symbol.iterator"),e}(),Se="function"==typeof WeakMap?WeakMap:function(n,o,t){function e(){o(this,n,{value:Be("WeakMap")})}return e.prototype={delete:function(e){delete e[this[n]]},get:function(e){return e[this[n]]},has:function(e){return t.call(e,this[n])},set:function(e,t){o(e,this[n],{configurable:!0,value:t})}},e}(Be("WeakMap"),Object.defineProperty,{}.hasOwnProperty),Pe={promise:new Se,innerParams:new Se,domCache:new Se};function Ee(){var e=Pe.innerParams.get(this),t=Pe.domCache.get(this);e.showConfirmButton||(F(t.confirmButton),e.showCancelButton||F(t.actions)),W([t.popup,t.actions],_.loading),t.popup.removeAttribute("aria-busy"),t.popup.removeAttribute("data-loading"),t.confirmButton.disabled=!1,t.cancelButton.disabled=!1}function Le(e){var t=Pe.domCache.get(this);t.validationMessage.innerHTML=e;var n=window.getComputedStyle(t.popup);t.validationMessage.style.marginLeft="-".concat(n.getPropertyValue("padding-left")),t.validationMessage.style.marginRight="-".concat(n.getPropertyValue("padding-right")),K(t.validationMessage);var o=this.getInput();o&&(o.setAttribute("aria-invalid",!0),o.setAttribute("aria-describedBy",_["validation-message"]),N(o),z(o,_.inputerror))}function Oe(){var e=Pe.domCache.get(this);e.validationMessage&&F(e.validationMessage);var t=this.getInput();t&&(t.removeAttribute("aria-invalid"),t.removeAttribute("aria-describedBy"),W(t,_.inputerror))}var Te=function e(t,n){a(this,e);var o,i,r=n;this.running=!1,this.start=function(){return this.running||(this.running=!0,i=new Date,o=setTimeout(t,r)),r},this.stop=function(){return this.running&&(this.running=!1,clearTimeout(o),r-=new Date-i),r},this.increase=function(e){var t=this.running;return t&&this.stop(),r+=e,t&&this.start(),r},this.getTimerLeft=function(){return this.running&&(this.stop(),this.start()),r},this.isRunning=function(){return this.running},this.start()},Me={email:function(e,t){return/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(e)?Promise.resolve():Promise.reject(t&&t.validationMessage?t.validationMessage:"Invalid email address")},url:function(e,t){return/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/.test(e)?Promise.resolve():Promise.reject(t&&t.validationMessage?t.validationMessage:"Invalid URL")}};var je=function(e){var t=w(),n=k();null!==e.onBeforeOpen&&"function"==typeof e.onBeforeOpen&&e.onBeforeOpen(n),e.animation?(z(n,_.show),z(t,_.fade),W(n,_.hide)):W(n,_.fade),K(n),t.style.overflowY="hidden",ee&&!v(n,_.noanimation)?n.addEventListener(ee,function e(){n.removeEventListener(ee,e),t.style.overflowY="auto"}):t.style.overflowY="auto",z([document.documentElement,document.body,t],_.shown),e.heightAuto&&e.backdrop&&!e.toast&&z([document.documentElement,document.body],_["height-auto"]),T()&&(se(),function(){if(/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream&&!v(document.body,_.iosfix)){var e=document.body.scrollTop;document.body.style.top=-1*e+"px",z(document.body,_.iosfix)}}(),"undefined"!=typeof window&&ce()&&(ue(),window.addEventListener("resize",ue)),f(document.body.children).forEach(function(e){e===w()||function(e,t){if("function"==typeof e.contains)return e.contains(t)}(e,w())||(e.hasAttribute("aria-hidden")&&e.setAttribute("data-previous-aria-hidden",e.getAttribute("aria-hidden")),e.setAttribute("aria-hidden","true"))}),setTimeout(function(){t.scrollTop=0})),M()||le.previousActiveElement||(le.previousActiveElement=document.activeElement),null!==e.onOpen&&"function"==typeof e.onOpen&&setTimeout(function(){e.onOpen(n)})};var Ve,qe=Object.freeze({hideLoading:Ee,disableLoading:Ee,getInput:function(e){var t=Pe.innerParams.get(this),n=Pe.domCache.get(this);if(!(e=e||t.input))return null;switch(e){case"select":case"textarea":case"file":return U(n.content,_[e]);case"checkbox":return n.popup.querySelector(".".concat(_.checkbox," input"));case"radio":return n.popup.querySelector(".".concat(_.radio," input:checked"))||n.popup.querySelector(".".concat(_.radio," input:first-child"));case"range":return n.popup.querySelector(".".concat(_.range," input"));default:return U(n.content,_.input)}},enableButtons:function(){var e=Pe.domCache.get(this);e.confirmButton.disabled=!1,e.cancelButton.disabled=!1},disableButtons:function(){var e=Pe.domCache.get(this);e.confirmButton.disabled=!0,e.cancelButton.disabled=!0},enableConfirmButton:function(){Pe.domCache.get(this).confirmButton.disabled=!1},disableConfirmButton:function(){Pe.domCache.get(this).confirmButton.disabled=!0},enableInput:function(){var e=this.getInput();if(!e)return!1;if("radio"===e.type)for(var t=e.parentNode.parentNode.querySelectorAll("input"),n=0;n<t.length;n++)t[n].disabled=!1;else e.disabled=!1},disableInput:function(){var e=this.getInput();if(!e)return!1;if(e&&"radio"===e.type)for(var t=e.parentNode.parentNode.querySelectorAll("input"),n=0;n<t.length;n++)t[n].disabled=!0;else e.disabled=!0},showValidationMessage:Le,resetValidationMessage:Oe,resetValidationError:function(){m("Swal.resetValidationError() is deprecated and will be removed in the next major release, use Swal.resetValidationMessage() instead"),Oe.bind(this)()},showValidationError:function(e){m("Swal.showValidationError() is deprecated and will be removed in the next major release, use Swal.showValidationMessage() instead"),Le.bind(this)(e)},getProgressSteps:function(){return Pe.innerParams.get(this).progressSteps},setProgressSteps:function(e){var t=r({},Pe.innerParams.get(this),{progressSteps:e});Pe.innerParams.set(this,t),re(t)},showProgressSteps:function(){var e=Pe.domCache.get(this);K(e.progressSteps)},hideProgressSteps:function(){var e=Pe.domCache.get(this);F(e.progressSteps)},_main:function(e){var T=this;ye(e);var M=r({},me,e);!function(t){var e;t.inputValidator||Object.keys(Me).forEach(function(e){t.input===e&&(t.inputValidator=t.expectRejections?Me[e]:De.adaptInputValidator(Me[e]))}),t.validationMessage&&("object"!==q(t.extraParams)&&(t.extraParams={}),t.extraParams.validationMessage=t.validationMessage),(!t.target||"string"==typeof t.target&&!document.querySelector(t.target)||"string"!=typeof t.target&&!t.target.appendChild)&&(R('Target parameter is not valid, defaulting to "body"'),t.target="body"),"function"==typeof t.animation&&(t.animation=t.animation.call());var n=k(),o="string"==typeof t.target?document.querySelector(t.target):t.target;e=n&&o&&n.parentNode!==o.parentNode?X(t):n||X(t),t.width&&(e.style.width="number"==typeof t.width?t.width+"px":t.width),t.padding&&(e.style.padding="number"==typeof t.padding?t.padding+"px":t.padding),t.background&&(e.style.background=t.background);for(var i=window.getComputedStyle(e).getPropertyValue("background-color"),r=e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix"),a=0;a<r.length;a++)r[a].style.backgroundColor=i;var s=w(),c=$(),u=Y();if(ae(t),ne(t),"string"==typeof t.backdrop?w().style.background=t.backdrop:t.backdrop||z([document.documentElement,document.body],_["no-backdrop"]),!t.backdrop&&t.allowOutsideClick&&R('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'),t.position in _?z(s,_[t.position]):(R('The "position" parameter is not valid, defaulting to "center"'),z(s,_.center)),t.grow&&"string"==typeof t.grow){var l="grow-"+t.grow;l in _&&z(s,_[l])}t.showCloseButton?(c.setAttribute("aria-label",t.closeButtonAriaLabel),K(c)):F(c),e.className=_.popup,t.toast?(z([document.documentElement,document.body],_["toast-shown"]),z(e,_.toast)):z(e,_.modal),t.customClass&&z(e,t.customClass),t.customContainerClass&&z(s,t.customContainerClass),re(t),oe(t),ie(t),te(t),G(t.footer,u),!0===t.animation?W(e,_.noanimation):z(e,_.noanimation),t.showLoaderOnConfirm&&!t.preConfirm&&R("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request")}(M),Object.freeze(M),Pe.innerParams.set(this,M),le.timeout&&(le.timeout.stop(),delete le.timeout),clearTimeout(le.restoreFocusTimeout);var j={popup:k(),container:w(),content:B(),actions:Q(),confirmButton:L(),cancelButton:O(),closeButton:$(),validationMessage:E(),progressSteps:P()};Pe.domCache.set(this,j);var V=this.constructor;return new Promise(function(t,n){var o=function(e){V.closePopup(M.onClose,M.onAfterClose),M.useRejections?t(e):t({value:e})},c=function(e){V.closePopup(M.onClose,M.onAfterClose),M.useRejections?n(e):t({dismiss:e})},u=function(e){V.closePopup(M.onClose,M.onAfterClose),n(e)};M.timer&&(le.timeout=new Te(function(){c("timer"),delete le.timeout},M.timer)),M.input&&setTimeout(function(){var e=T.getInput();e&&N(e)},0);for(var l=function(t){if(M.showLoaderOnConfirm&&V.showLoading(),M.preConfirm){T.resetValidationMessage();var e=Promise.resolve().then(function(){return M.preConfirm(t,M.extraParams)});M.expectRejections?e.then(function(e){return o(e||t)},function(e){T.hideLoading(),e&&T.showValidationMessage(e)}):e.then(function(e){Z(j.validationMessage)||!1===e?T.hideLoading():o(e||t)},function(e){return u(e)})}else o(t)},e=function(e){var t=e.target,n=j.confirmButton,o=j.cancelButton,i=n&&(n===t||n.contains(t)),r=o&&(o===t||o.contains(t));switch(e.type){case"click":if(i&&V.isVisible())if(T.disableButtons(),M.input){var a=function(){var e=T.getInput();if(!e)return null;switch(M.input){case"checkbox":return e.checked?1:0;case"radio":return e.checked?e.value:null;case"file":return e.files.length?e.files[0]:null;default:return M.inputAutoTrim?e.value.trim():e.value}}();if(M.inputValidator){T.disableInput();var s=Promise.resolve().then(function(){return M.inputValidator(a,M.extraParams)});M.expectRejections?s.then(function(){T.enableButtons(),T.enableInput(),l(a)},function(e){T.enableButtons(),T.enableInput(),e&&T.showValidationMessage(e)}):s.then(function(e){T.enableButtons(),T.enableInput(),e?T.showValidationMessage(e):l(a)},function(e){return u(e)})}else T.getInput().checkValidity()?l(a):(T.enableButtons(),T.showValidationMessage(M.validationMessage))}else l(!0);else r&&V.isVisible()&&(T.disableButtons(),c(V.DismissReason.cancel))}},i=j.popup.querySelectorAll("button"),r=0;r<i.length;r++)i[r].onclick=e,i[r].onmouseover=e,i[r].onmouseout=e,i[r].onmousedown=e;if(j.closeButton.onclick=function(){c(V.DismissReason.close)},M.toast)j.popup.onclick=function(){M.showConfirmButton||M.showCancelButton||M.showCloseButton||M.input||c(V.DismissReason.close)};else{var a=!1;j.popup.onmousedown=function(){j.container.onmouseup=function(e){j.container.onmouseup=void 0,e.target===j.container&&(a=!0)}},j.container.onmousedown=function(){j.popup.onmouseup=function(e){j.popup.onmouseup=void 0,(e.target===j.popup||j.popup.contains(e.target))&&(a=!0)}},j.container.onclick=function(e){a?a=!1:e.target===j.container&&H(M.allowOutsideClick)&&c(V.DismissReason.backdrop)}}M.reverseButtons?j.confirmButton.parentNode.insertBefore(j.cancelButton,j.confirmButton):j.confirmButton.parentNode.insertBefore(j.confirmButton,j.cancelButton);var s=function(e,t){for(var n=J(M.focusCancel),o=0;o<n.length;o++)return(e+=t)===n.length?e=0:-1===e&&(e=n.length-1),n[e].focus();j.popup.focus()};le.keydownHandlerAdded&&(le.keydownTarget.removeEventListener("keydown",le.keydownHandler,{capture:le.keydownListenerCapture}),le.keydownHandlerAdded=!1),M.toast||(le.keydownHandler=function(e){return function(e,t){if(t.stopKeydownPropagation&&e.stopPropagation(),"Enter"!==e.key||e.isComposing)if("Tab"===e.key){for(var n=e.target,o=J(t.focusCancel),i=-1,r=0;r<o.length;r++)if(n===o[r]){i=r;break}e.shiftKey?s(i,-1):s(i,1),e.stopPropagation(),e.preventDefault()}else-1!==["ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Left","Right","Up","Down"].indexOf(e.key)?document.activeElement===j.confirmButton&&Z(j.cancelButton)?j.cancelButton.focus():document.activeElement===j.cancelButton&&Z(j.confirmButton)&&j.confirmButton.focus():"Escape"!==e.key&&"Esc"!==e.key||!0!==H(t.allowEscapeKey)||(e.preventDefault(),c(V.DismissReason.esc));else if(e.target&&T.getInput()&&e.target.outerHTML===T.getInput().outerHTML){if(-1!==["textarea","file"].indexOf(t.input))return;V.clickConfirm(),e.preventDefault()}}(e,M)},le.keydownTarget=M.keydownListenerCapture?window:j.popup,le.keydownListenerCapture=M.keydownListenerCapture,le.keydownTarget.addEventListener("keydown",le.keydownHandler,{capture:le.keydownListenerCapture}),le.keydownHandlerAdded=!0),T.enableButtons(),T.hideLoading(),T.resetValidationMessage(),M.toast&&(M.input||M.footer||M.showCloseButton)?z(document.body,_["toast-column"]):W(document.body,_["toast-column"]);for(var d,p,f=["input","file","range","select","radio","checkbox","textarea"],m=function(e){e.placeholder&&!M.inputPlaceholder||(e.placeholder=M.inputPlaceholder)},h=0;h<f.length;h++){var g=_[f[h]],b=U(j.content,g);if(d=T.getInput(f[h])){for(var v in d.attributes)if(d.attributes.hasOwnProperty(v)){var y=d.attributes[v].name;"type"!==y&&"value"!==y&&d.removeAttribute(y)}for(var w in M.inputAttributes)"range"===f[h]&&"placeholder"===w||d.setAttribute(w,M.inputAttributes[w])}b.className=g,M.inputClass&&z(b,M.inputClass),F(b)}switch(M.input){case"text":case"email":case"password":case"number":case"tel":case"url":d=U(j.content,_.input),"string"==typeof M.inputValue||"number"==typeof M.inputValue?d.value=M.inputValue:D(M.inputValue)||R('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(q(M.inputValue),'"')),m(d),d.type=M.input,K(d);break;case"file":m(d=U(j.content,_.file)),d.type=M.input,K(d);break;case"range":var C=U(j.content,_.range),k=C.querySelector("input"),x=C.querySelector("output");k.value=M.inputValue,k.type=M.input,x.value=M.inputValue,K(C);break;case"select":var A=U(j.content,_.select);if(A.innerHTML="",M.inputPlaceholder){var B=document.createElement("option");B.innerHTML=M.inputPlaceholder,B.value="",B.disabled=!0,B.selected=!0,A.appendChild(B)}p=function(e){e.forEach(function(e){var t=e[0],n=e[1],o=document.createElement("option");o.value=t,o.innerHTML=n,M.inputValue.toString()===t.toString()&&(o.selected=!0),A.appendChild(o)}),K(A),A.focus()};break;case"radio":var S=U(j.content,_.radio);S.innerHTML="",p=function(e){e.forEach(function(e){var t=e[0],n=e[1],o=document.createElement("input"),i=document.createElement("label");o.type="radio",o.name=_.radio,o.value=t,M.inputValue.toString()===t.toString()&&(o.checked=!0);var r=document.createElement("span");r.innerHTML=n,r.className=_.label,i.appendChild(o),i.appendChild(r),S.appendChild(i)}),K(S);var t=S.querySelectorAll("input");t.length&&t[0].focus()};break;case"checkbox":var P=U(j.content,_.checkbox),E=T.getInput("checkbox");E.type="checkbox",E.value=1,E.id=_.checkbox,E.checked=Boolean(M.inputValue),P.querySelector("span").innerHTML=M.inputPlaceholder,K(P);break;case"textarea":var L=U(j.content,_.textarea);L.value=M.inputValue,m(L),K(L);break;case null:break;default:I('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'.concat(M.input,'"'))}if("select"===M.input||"radio"===M.input){var O=function(e){return p((t=e,n=[],"undefined"!=typeof Map&&t instanceof Map?t.forEach(function(e,t){n.push([t,e])}):Object.keys(t).forEach(function(e){n.push([e,t[e]])}),n));var t,n};D(M.inputOptions)?(V.showLoading(),M.inputOptions.then(function(e){T.hideLoading(),O(e)})):"object"===q(M.inputOptions)?O(M.inputOptions):I("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(q(M.inputOptions)))}else-1!==["text","email","number","tel","textarea"].indexOf(M.input)&&D(M.inputValue)&&(V.showLoading(),F(d),M.inputValue.then(function(e){d.value="number"===M.input?parseFloat(e)||0:e+"",K(d),d.focus(),T.hideLoading()}).catch(function(e){I("Error in inputValue promise: "+e),d.value="",K(d),d.focus(),T.hideLoading()}));je(M),M.toast||(H(M.allowEnterKey)?M.focusCancel&&Z(j.cancelButton)?j.cancelButton.focus():M.focusConfirm&&Z(j.confirmButton)?j.confirmButton.focus():s(-1,1):document.activeElement&&"function"==typeof document.activeElement.blur&&document.activeElement.blur()),j.container.scrollTop=0})}});function Re(){if("undefined"!=typeof window){"undefined"==typeof Promise&&I("This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)"),Ve=this;for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];var o=Object.freeze(this.constructor.argsToParams(t));Object.defineProperties(this,{params:{value:o,writable:!1,enumerable:!0}});var i=this._main(this.params);Pe.promise.set(this,i)}}Re.prototype.then=function(e,t){return Pe.promise.get(this).then(e,t)},Re.prototype.catch=function(e){return Pe.promise.get(this).catch(e)},Re.prototype.finally=function(e){return Pe.promise.get(this).finally(e)},r(Re.prototype,qe),r(Re,Ae),Object.keys(qe).forEach(function(t){Re[t]=function(){var e;if(Ve)return(e=Ve)[t].apply(e,arguments)}}),Re.DismissReason=e,Re.noop=function(){};var Ie,He,De=fe((Ie=Re,He=function(e){function t(){return a(this,t),d(this,c(t).apply(this,arguments))}return s(t,Ie),i(t,[{key:"_main",value:function(e){return p(c(t.prototype),"_main",this).call(this,r({},Ce,e))}}],[{key:"setDefaults",value:function(t){if(m(we),!t||"object"!==q(t))throw new TypeError("SweetAlert2: The argument for setDefaults() is required and has to be a object");ye(t),Object.keys(t).forEach(function(e){Ie.isValidParameter(e)&&(Ce[e]=t[e])})}},{key:"resetDefaults",value:function(){m(we),Ce={}}}]),t}(),"undefined"!=typeof window&&"object"===q(window._swalDefaults)&&He.setDefaults(window._swalDefaults),He));return De.default=De}),"undefined"!=typeof window&&window.Sweetalert2&&(window.Sweetalert2.version="7.33.1",window.swal=window.sweetAlert=window.Swal=window.SweetAlert=window.Sweetalert2);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("27542614", content, true, {});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}to{top:2.8125em;left:.875em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}to{top:2.8125em;left:.875em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}to{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}to{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}to{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}to{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}body.swal2-toast-shown .swal2-container,body.swal2-toast-shown .swal2-container.swal2-shown{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{flex-direction:column;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast{flex-direction:row;align-items:center;width:auto;padding:.625em;box-shadow:0 0 .625em #d9d9d9;overflow-y:hidden}.swal2-popup.swal2-toast .swal2-header{flex-direction:row}.swal2-popup.swal2-toast .swal2-title{flex-grow:1;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{justify-content:flex-start;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon-text{font-size:2em;font-weight:700;line-height:1em}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{height:auto;margin:0 .3125em}.swal2-popup.swal2-toast .swal2-styled{margin:0 .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 .0625em #fff,0 0 0 .125em rgba(50,100,150,.4)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:2em;height:2.8125em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.25em;left:-.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:2em 2em;transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;-webkit-transform-origin:0 2em;transform-origin:0 2em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:showSweetToast .5s;animation:showSweetToast .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:hideSweetToast .2s forwards;animation:hideSweetToast .2s forwards}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:animate-toast-success-tip .75s;animation:animate-toast-success-tip .75s}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:animate-toast-success-long .75s;animation:animate-toast-success-long .75s}@-webkit-keyframes showSweetToast{0%{-webkit-transform:translateY(-.625em) rotate(2deg);transform:translateY(-.625em) rotate(2deg);opacity:0}33%{-webkit-transform:translateY(0) rotate(-2deg);transform:translateY(0) rotate(-2deg);opacity:.5}66%{-webkit-transform:translateY(.3125em) rotate(2deg);transform:translateY(.3125em) rotate(2deg);opacity:.7}to{-webkit-transform:translateY(0) rotate(0);transform:translateY(0) rotate(0);opacity:1}}@keyframes showSweetToast{0%{-webkit-transform:translateY(-.625em) rotate(2deg);transform:translateY(-.625em) rotate(2deg);opacity:0}33%{-webkit-transform:translateY(0) rotate(-2deg);transform:translateY(0) rotate(-2deg);opacity:.5}66%{-webkit-transform:translateY(.3125em) rotate(2deg);transform:translateY(.3125em) rotate(2deg);opacity:.7}to{-webkit-transform:translateY(0) rotate(0);transform:translateY(0) rotate(0);opacity:1}}@-webkit-keyframes hideSweetToast{0%{opacity:1}33%{opacity:.5}to{-webkit-transform:rotate(1deg);transform:rotate(1deg);opacity:0}}@keyframes hideSweetToast{0%{opacity:1}33%{opacity:.5}to{-webkit-transform:rotate(1deg);transform:rotate(1deg);opacity:0}}@-webkit-keyframes animate-toast-success-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}to{top:1.125em;left:.1875em;width:.75em}}@keyframes animate-toast-success-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}to{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes animate-toast-success-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}to{top:.9375em;right:.1875em;width:1.375em}}@keyframes animate-toast-success-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}to{top:.9375em;right:.1875em;width:1.375em}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-shown{top:auto;right:auto;bottom:auto;left:auto;background-color:transparent}body.swal2-no-backdrop .swal2-shown>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-shown.swal2-top{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-top-left,body.swal2-no-backdrop .swal2-shown.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-top-end,body.swal2-no-backdrop .swal2-shown.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-shown.swal2-center{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-left,body.swal2-no-backdrop .swal2-shown.swal2-center-start{top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-end,body.swal2-no-backdrop .swal2-shown.swal2-center-right{top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom{bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom-left,body.swal2-no-backdrop .swal2-shown.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-bottom-end,body.swal2-no-backdrop .swal2-shown.swal2-bottom-right{right:0;bottom:0}.swal2-container{display:flex;position:fixed;top:0;right:0;bottom:0;left:0;flex-direction:row;align-items:center;justify-content:center;padding:10px;background-color:transparent;z-index:1060;overflow-x:hidden;-webkit-overflow-scrolling:touch}.swal2-container.swal2-top{align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{align-items:flex-start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{align-items:flex-start;justify-content:flex-end}.swal2-container.swal2-center{align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{align-items:center;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{align-items:center;justify-content:flex-end}.swal2-container.swal2-bottom{align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{align-items:flex-end;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{align-items:flex-end;justify-content:flex-end}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:flex!important;flex:1;align-self:stretch;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-grow-column{flex:1;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.swal2-container .swal2-modal{margin:0!important}}.swal2-container.swal2-fade{transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-popup{display:none;position:relative;flex-direction:column;justify-content:center;width:32em;max-width:100%;padding:1.25em;border-radius:.3125em;background:#fff;font-family:inherit;font-size:1rem;box-sizing:border-box}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-popup .swal2-header{display:flex;flex-direction:column;align-items:center}.swal2-popup .swal2-title{display:block;position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-popup .swal2-actions{flex-wrap:wrap;align-items:center;justify-content:center;margin:1.25em auto 0;z-index:1}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-confirm{width:2.5em;height:2.5em;margin:.46875em;padding:0;border:.25em solid transparent;border-radius:100%;border-color:transparent;background-color:transparent!important;color:transparent;cursor:default;box-sizing:border-box;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-cancel{margin-right:30px;margin-left:30px}.swal2-popup .swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm:after{display:inline-block;width:15px;height:15px;margin-left:5px;border:3px solid #999;border-radius:50%;border-right-color:transparent;box-shadow:1px 1px 1px #fff;content:\"\";-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal}.swal2-popup .swal2-styled{margin:.3125em;padding:.625em 2em;font-weight:500;box-shadow:none}.swal2-popup .swal2-styled:not([disabled]){cursor:pointer}.swal2-popup .swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#3085d6;color:#fff;font-size:1.0625em}.swal2-popup .swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#aaa;color:#fff;font-size:1.0625em}.swal2-popup .swal2-styled:focus{outline:0;box-shadow:0 0 0 2px #fff,0 0 0 4px rgba(50,100,150,.4)}.swal2-popup .swal2-styled::-moz-focus-inner{border:0}.swal2-popup .swal2-footer{justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-popup .swal2-image{max-width:100%;margin:1.25em auto}.swal2-popup .swal2-close{position:absolute;top:0;right:0;justify-content:center;width:1.2em;height:1.2em;padding:0;transition:color .1s ease-out;border:none;border-radius:0;outline:initial;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer;overflow:hidden}.swal2-popup .swal2-close:hover{-webkit-transform:none;transform:none;color:#f27474}.swal2-popup>.swal2-checkbox,.swal2-popup>.swal2-file,.swal2-popup>.swal2-input,.swal2-popup>.swal2-radio,.swal2-popup>.swal2-select,.swal2-popup>.swal2-textarea{display:none}.swal2-popup .swal2-content{justify-content:center;margin:0;padding:0;color:#545454;font-size:1.125em;font-weight:300;line-height:normal;z-index:1;word-wrap:break-word}.swal2-popup #swal2-content{text-align:center}.swal2-popup .swal2-checkbox,.swal2-popup .swal2-file,.swal2-popup .swal2-input,.swal2-popup .swal2-radio,.swal2-popup .swal2-select,.swal2-popup .swal2-textarea{margin:1em auto}.swal2-popup .swal2-file,.swal2-popup .swal2-input,.swal2-popup .swal2-textarea{width:100%;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;font-size:1.125em;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);box-sizing:border-box}.swal2-popup .swal2-file.swal2-inputerror,.swal2-popup .swal2-input.swal2-inputerror,.swal2-popup .swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-popup .swal2-file:focus,.swal2-popup .swal2-input:focus,.swal2-popup .swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 3px #c4e6f5}.swal2-popup .swal2-file::-webkit-input-placeholder,.swal2-popup .swal2-input::-webkit-input-placeholder,.swal2-popup .swal2-textarea::-webkit-input-placeholder{color:#ccc}.swal2-popup .swal2-file:-ms-input-placeholder,.swal2-popup .swal2-file::-ms-input-placeholder,.swal2-popup .swal2-input:-ms-input-placeholder,.swal2-popup .swal2-input::-ms-input-placeholder,.swal2-popup .swal2-textarea:-ms-input-placeholder,.swal2-popup .swal2-textarea::-ms-input-placeholder{color:#ccc}.swal2-popup .swal2-file::placeholder,.swal2-popup .swal2-input::placeholder,.swal2-popup .swal2-textarea::placeholder{color:#ccc}.swal2-popup .swal2-range input{width:80%}.swal2-popup .swal2-range output{width:20%;font-weight:600;text-align:center}.swal2-popup .swal2-range input,.swal2-popup .swal2-range output{height:2.625em;margin:1em auto;padding:0;font-size:1.125em;line-height:2.625em}.swal2-popup .swal2-input{height:2.625em;padding:0 .75em}.swal2-popup .swal2-input[type=number]{max-width:10em}.swal2-popup .swal2-file{font-size:1.125em}.swal2-popup .swal2-textarea{height:6.75em;padding:.75em}.swal2-popup .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;color:#545454;font-size:1.125em}.swal2-popup .swal2-checkbox,.swal2-popup .swal2-radio{align-items:center;justify-content:center}.swal2-popup .swal2-checkbox label,.swal2-popup .swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-popup .swal2-checkbox input,.swal2-popup .swal2-radio input{margin:0 .4em}.swal2-popup .swal2-validation-message{display:none;align-items:center;justify-content:center;padding:.625em;background:#f0f0f0;color:#666;font-size:1em;font-weight:300;overflow:hidden}.swal2-popup .swal2-validation-message:before{display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center;content:\"!\";zoom:normal}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-moz-document url-prefix(){.swal2-close:focus{outline:2px solid rgba(50,100,150,.4)}}.swal2-icon{position:relative;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;line-height:5em;cursor:default;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;zoom:normal}.swal2-icon-text{font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:3.75em 3.75em;transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 3.75em;transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;top:-.25em;left:-.25em;width:100%;height:100%;border:.25em solid hsla(98,55%,69%,.3);border-radius:50%;z-index:2;box-sizing:content-box}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;top:.5em;left:1.625em;width:.4375em;height:5.625em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);z-index:1}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;height:.3125em;border-radius:.125em;background-color:#a5dc86;z-index:2}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.875em;width:1.5625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progresssteps{align-items:center;margin:0 0 1.25em;padding:0;font-weight:600}.swal2-progresssteps li{display:inline-block;position:relative}.swal2-progresssteps .swal2-progresscircle{width:2em;height:2em;border-radius:2em;background:#3085d6;color:#fff;line-height:2em;text-align:center;z-index:20}.swal2-progresssteps .swal2-progresscircle:first-child{margin-left:0}.swal2-progresssteps .swal2-progresscircle:last-child{margin-right:0}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep{background:#3085d6}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progresscircle,.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progressline{background:#add8e6}.swal2-progresssteps .swal2-progressline{width:2.5em;height:.4em;margin:0 -1px;background:#3085d6;z-index:10}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-animate-success-icon .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-animate-error-icon{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-animate-error-icon .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}@-webkit-keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_Home_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_Login_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_logout_Logout_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_choice_template_ChoiceTemplate_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_choice_products_ChoiceProducts_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_choice_options_ChoiceOptions_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_circular_list_CircularList_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generate2x_Generate2x_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generate3x_Generate3x_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generate4x_Generate4x_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generate5x_Generate5x_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generate6x_Generate6x_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generate7x_Generate7x_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generate8x_Generate8x_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_generate9x_Generate9x_vue__ = __webpack_require__(161);
















var routes = [{
  path: "",
  component: __WEBPACK_IMPORTED_MODULE_3__components_choice_template_ChoiceTemplate_vue__["a" /* default */]
}, {
  path: "/login",
  component: __WEBPACK_IMPORTED_MODULE_1__components_login_Login_vue__["a" /* default */]
}, {
  path: "/logout",
  component: __WEBPACK_IMPORTED_MODULE_2__components_logout_Logout_vue__["a" /* default */]
}, {
  path: "/nova-circular",
  component: __WEBPACK_IMPORTED_MODULE_3__components_choice_template_ChoiceTemplate_vue__["a" /* default */]
}, {
  path: "/escolher-produtos/:id_template",
  component: __WEBPACK_IMPORTED_MODULE_4__components_choice_products_ChoiceProducts_vue__["a" /* default */]
}, {
  name: "opcoes_circular",
  path: "/opcoes-circular",
  component: __WEBPACK_IMPORTED_MODULE_5__components_choice_options_ChoiceOptions_vue__["a" /* default */]
}, {
  path: "/gerar",
  component: __WEBPACK_IMPORTED_MODULE_6__components_circular_list_CircularList_vue__["a" /* default */]
}, {
  name: "gera_circular_2x",
  path: "/gerar-circular-2",
  component: __WEBPACK_IMPORTED_MODULE_7__components_generate2x_Generate2x_vue__["a" /* default */]
}, {
  name: "gera_circular_3x",
  path: "/gerar-circular-3",
  component: __WEBPACK_IMPORTED_MODULE_8__components_generate3x_Generate3x_vue__["a" /* default */]
}, {
  name: "gera_circular_4x",
  path: "/gerar-circular-4",
  component: __WEBPACK_IMPORTED_MODULE_9__components_generate4x_Generate4x_vue__["a" /* default */]
}, {
  name: "gera_circular_5x",
  path: "/gerar-circular-5",
  component: __WEBPACK_IMPORTED_MODULE_10__components_generate5x_Generate5x_vue__["a" /* default */]
}, {
  name: "gera_circular_6x",
  path: "/gerar-circular-6",
  component: __WEBPACK_IMPORTED_MODULE_11__components_generate6x_Generate6x_vue__["a" /* default */]
}, {
  name: "gera_circular_7x",
  path: "/gerar-circular-7",
  component: __WEBPACK_IMPORTED_MODULE_12__components_generate7x_Generate7x_vue__["a" /* default */]
}, {
  name: "gera_circular_8x",
  path: "/gerar-circular-8",
  component: __WEBPACK_IMPORTED_MODULE_13__components_generate8x_Generate8x_vue__["a" /* default */]
}, {
  name: "gera_circular_9x",
  path: "/gerar-circular-9",
  component: __WEBPACK_IMPORTED_MODULE_14__components_generate9x_Generate9x_vue__["a" /* default */]
}];

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(19);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4dde312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4dde312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4dde312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1b3cf97f", content, true, {});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main[data-v-c4dde312]{padding-left:300px}", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(62);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2ddd6edc", content, true, {});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"sidenav fixed z-depth-2",staticStyle:{"transform":"translateX(0%)"},attrs:{"id":"slide-out"}},[_vm._m(0),_vm._v(" "),_c('li',{attrs:{"id":"dash_dashboard"}},[_c('router-link',{staticClass:"waves-effect",staticStyle:{"padding":"0 16px"},attrs:{"to":"/"}},[_c('b',[_vm._v("Dashboard")])])],1),_vm._v(" "),_c('ul',{staticClass:"collapsible",attrs:{"data-collapsible":"accordion"}},[_c('li',{attrs:{"id":"dash_users"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body",attrs:{"id":"dash_users_body"}},[_c('ul',[_c('li',{attrs:{"id":"users_seller"}},[_c('router-link',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"to":"/nova-circular"}},[_vm._v("\n                                Nova\n                            ")])],1),_vm._v(" "),_c('li',{attrs:{"id":"users_customer"}},[_c('router-link',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"to":"/gerar"}},[_vm._v("\n                                Gerar\n                            ")])],1)])])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"center no-padding"},[_c('div',{staticClass:"teal light-2 white-text",staticStyle:{"height":"180px"}},[_c('div',{staticClass:"row"},[_c('img',{staticClass:" responsive-img",staticStyle:{"margin-top":"5%"},attrs:{"width":"100","height":"100","src":__webpack_require__(16)}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"-3%"}},[_vm._v("\n                        Circular de Ofertas\n                    ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header waves-effect",attrs:{"id":"dash_users_header"}},[_c('b',[_vm._v("Circular")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"id":"dash_products"}},[_c('div',{staticClass:"collapsible-header waves-effect",attrs:{"id":"dash_products_header"}},[_c('b',[_vm._v("Relatórios")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body",attrs:{"id":"dash_products_body"}},[_c('ul',[_c('li',{attrs:{"id":"products_product"}},[_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Produtos mais usados")]),_vm._v(" "),_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Templates mais usados")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(65);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4aa99536", content, true, {});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "header[data-v-697c0528]{padding-left:300px}.breadcrumb[data-v-697c0528]:first-child{margin-left:20px}", ""]);

// exports


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._m(0),_vm._v(" "),_c('nav',[_c('div',{staticClass:"nav-wrapper teal darken-2"},[_vm._l((_vm.breadcrumb),function(bread){return _c('router-link',{key:bread.url,staticClass:"breadcrumb",staticStyle:{"text-decoration":"none"},attrs:{"to":bread.url}},[_vm._v("\n        "+_vm._s(bread.title)+"\n        ")])}),_vm._v(" "),_c('div',{staticClass:"right",staticStyle:{"margin-right":"20px"},attrs:{"id":"timestamp"}})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"teal",attrs:{"role":"navigation"}},[_c('div',{staticClass:"nav-wrapper"},[_c('ul',{staticClass:"right hide-on-med-and-down"},[_c('li',[_c('a',{staticClass:"right",attrs:{"href":"/logout","data-target":"user_dropdown"}},[_c('i',{staticClass:" material-icons"},[_vm._v("exit_to_app")])])])]),_vm._v(" "),_c('a',{staticClass:"button-collapse",attrs:{"href":"#","data-activates":"slide-out"}},[_c('i',{staticClass:"mdi-navigation-menu"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-theme',{attrs:{"breadcrumb":this.breads}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('div',{staticClass:"card",staticStyle:{"padding":"35px"},attrs:{"align":"center"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('router-link',{attrs:{"to":"/nova-circular"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("add")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Nova")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/gerar"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("print")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Gerar")])])])])],1)])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('div',{staticClass:"card",staticStyle:{"padding":"35px"},attrs:{"align":"center"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('router-link',{attrs:{"to":"/logout"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("exit_to_app")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Sair")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")])],1)])])])]),_vm._v(" "),_c('side-menu')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"left card-title"},[_c('b',[_vm._v("Circular de Ofertas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s6"},[_c('div',{staticClass:"card",staticStyle:{"padding":"35px"},attrs:{"align":"center"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left card-title"},[_c('b',[_vm._v("Relatórios")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{attrs:{"href":"#!"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("store")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Produtos")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('a',{attrs:{"href":"#!"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Templates")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s6"},[_c('div',{staticClass:"card",staticStyle:{"padding":"35px"},attrs:{"align":"center"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left card-title"},[_c('b',[_vm._v("Usuário")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{attrs:{"href":"#!"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Editar dados")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_vm._v(" ")]),_vm._v(" "),_c('a',{attrs:{"href":"#!"}},[_c('div',{staticClass:"grey lighten-3 col s5 waves-effect",staticStyle:{"padding":"30px"}},[_c('i',{staticClass:"teal-text text-lighten-1 large material-icons"},[_vm._v("vpn_key")]),_vm._v(" "),_c('span',{staticClass:"teal-text text-lighten-1"},[_c('h5',[_vm._v("Trocar senha")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"left card-title"},[_c('b',[_vm._v("Sistema")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a93774_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(71);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59a93774"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a93774_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4c4bd496", content, true, {});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"center-align"},[_vm._v("Circular de Ofertas")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{staticClass:"col s12",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s4 offset-s4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],attrs:{"type":"email"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("E-mail")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s4 offset-s4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],attrs:{"type":"password"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Senha")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4 offset-s5"},[_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberEmail),expression:"rememberEmail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.rememberEmail)?_vm._i(_vm.rememberEmail,null)>-1:(_vm.rememberEmail)},on:{"change":function($event){var $$a=_vm.rememberEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberEmail=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberEmail=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberEmail=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("Lembrar meu e-mail")])])])])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col s2 offset-s5"},[_c('img',{staticClass:"responsive-img",attrs:{"src":__webpack_require__(16),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('button',{staticClass:"col s2 offset-s5 waves-effect waves-light btn",attrs:{"name":"submit"}},[_vm._v("entrar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb4199b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(75);
function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb4199b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb4199b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f89d2344", content, true, {});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content[data-v-eb4199b2]{height:100vh}", ""]);

// exports


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"valign-wrapper"},[_c('h5',{staticClass:"teal-text"},[_vm._v("Saindo do sistema. "),_c('small',[_vm._v("Você será redirecionado para a página de login.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceTemplate_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a7d1ea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceTemplate_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80a7d1ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a7d1ea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(78);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7839cff7", content, true, {});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".height100[data-v-80a7d1ea]{height:100vh}#left-bar[data-v-80a7d1ea]{border-right:2px solid #dee4ea}#steps-container[data-v-80a7d1ea]{position:absolute;left:50%;transform:translateX(-50%);margin-top:10%}.step[data-v-80a7d1ea]{width:2.5em;height:2.5em;text-align:center;line-height:2.5em;position:relative;margin-bottom:10px;float:left;margin-left:5px}.step span[data-v-80a7d1ea]{position:relative;font-family:Helvetica Neue,Arial,sans-serif;font-weight:200;font-size:1.5em;color:#8f9297;z-index:1000;white-space:nowrap}.step.active span[data-v-80a7d1ea]{color:#478ff1}.step[data-v-80a7d1ea]:before{left:5%;top:5%;height:90%;width:90%;z-index:600}.step[data-v-80a7d1ea]:after,.step[data-v-80a7d1ea]:before{position:absolute;background:#fff;content:\"\";border-radius:50%}.step[data-v-80a7d1ea]:after{left:0;top:0;height:100%;width:100%;z-index:500}.step.active[data-v-80a7d1ea]:after{background:#478ff1}.center-el[data-v-80a7d1ea]{position:relative;left:50%;transform:translateX(-50%)}", ""]);

// exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(80);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("846b5b18", content, true, {});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".height100[data-v-5de1e7e4]{height:100vh}#left-bar[data-v-5de1e7e4]{border-right:2px solid #dee4ea}#steps-container[data-v-5de1e7e4]{position:absolute;left:50%;transform:translateX(-50%);margin-top:10%}.step[data-v-5de1e7e4]{width:2.5em;height:2.5em;text-align:center;line-height:2.5em;position:relative;margin-bottom:10px;float:left;margin-left:5px}.step span[data-v-5de1e7e4]{position:relative;font-family:Helvetica Neue,Arial,sans-serif;font-weight:200;font-size:1.5em;color:#8f9297;z-index:1000;white-space:nowrap}.step.active span[data-v-5de1e7e4]{color:#478ff1}.step[data-v-5de1e7e4]:before{left:5%;top:5%;height:90%;width:90%;z-index:600}.step[data-v-5de1e7e4]:after,.step[data-v-5de1e7e4]:before{position:absolute;background:#fff;content:\"\";border-radius:50%}.step[data-v-5de1e7e4]:after{left:0;top:0;height:100%;width:100%;z-index:500}.step.active[data-v-5de1e7e4]:after{background:#478ff1}.center-el[data-v-5de1e7e4]{position:relative;left:50%;transform:translateX(-50%)}", ""]);

// exports


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row",staticStyle:{"position":"fixed !important","width":"100%"}},[_c('div',{staticClass:"col s3 white height100",staticStyle:{"position":"relative"},attrs:{"id":"left-bar"}},[_c('div',{attrs:{"id":"steps-container"}},[_c('router-link',{attrs:{"to":"/nova-circular"}},[_c('div',{staticClass:"step",class:{ active: _vm.step === 1 }},[_c('span',[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"step",class:{ active: _vm.step === 2 }},[_c('span',[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"step",class:{ active: _vm.step === 3 }},[_c('span',[_vm._v("3")])])],1),_vm._v(" "),_c('img',{staticClass:"responsive-img center-el",staticStyle:{"width":"40%","margin-top":"50%"},attrs:{"src":__webpack_require__(16),"alt":""}}),_vm._v(" "),_c('h6',{staticClass:"center-align",staticStyle:{"font-weight":"bold","color":"#8F9297"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 offset-s3"},[_c('p',{staticClass:"center-align",staticStyle:{"font-weight":"200","color":"#8F9297"}},[_vm._v("\n                        "+_vm._s(_vm.subtitle)+"\n                    ")])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col s9 white height100",staticStyle:{"overflow-y":"scroll"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"position":"fixed","width":"100%","background-color":"#fff","z-index":"9999"}},[_c('h3',{staticStyle:{"font-weight":"300","color":"#2F3F52"}},[_vm._v("\n                        "+_vm._s(_vm.pagetitle)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"110px"}},[_vm._t("default")],2)])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"position":"absolute","bottom":"20px"}},[_c('div',{staticClass:"col s7 offset-s3"},[_c('p',{staticClass:"center-align",staticStyle:{"font-weight":"200","color":"#8F9297"}},[_vm._v("\n                        Problemas? Entre em contato clicando "),_c('a',{attrs:{"href":"#"}},[_vm._v("aqui")]),_vm._v(".\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-action-btn"},[_c('a',{staticClass:"btn-floating btn-large teal"},[_c('i',{staticClass:"large material-icons"},[_vm._v("menu")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"btn-floating blue-accent tooltipped",attrs:{"href":"/","data-position":"left","data-tooltip":"Início"}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn-floating red darken-2 tooltipped",attrs:{"href":"/logout","data-position":"left","data-tooltip":"Sair do sistema"}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-circular-new',{attrs:{"pagetitle":"Templates","step":1,"title":"Escolha um template","subtitle":"Escolha o template que irá utilizar para criar sua nova circular de produtos."}},[_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(83)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 2 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/1"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(84)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 3 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/2"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(85)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 5 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/4"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(86)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 6 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/5"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(87)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 7 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/6"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(88)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 8 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/7"}},[_vm._v("Escolher")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('div',{staticClass:"card horizontal"},[_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":__webpack_require__(89)}})]),_vm._v(" "),_c('div',{staticClass:"card-stacked"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Template com 9 itens.")])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('router-link',{staticStyle:{"color":"#478FF1"},attrs:{"to":"/escolher-produtos/8"}},[_vm._v("Escolher")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com2.jpg?0d1db3a7e0f0675b69172a4165f28c24";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com3.jpg?5fff891a7ac20cc41ac4b96dcf086422";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com5.jpg?6c4ef66b74ec206132119a25e37a8684";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com6.jpg?545a04853ae2c4704e9a29c08c869966";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com7.jpg?8e8ade323b3fd2595790d19e4a28f59e";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com8.jpg?17955d940d6f479d41ca2130394d77bc";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layout_com9.jpg?e80d99281e5121ae9d10b9539d1cc39a";

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceProducts_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c3d3dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceProducts_vue__ = __webpack_require__(98);
function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44c3d3dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c3d3dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(92);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("123a359a", content, true, {});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd7a932_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__ = __webpack_require__(96);
function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd7a932_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(95);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("38313386", content, true, {});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".autocomplete{position:relative}.autocomplete-results{padding:0;margin:0;border:1px solid #eee;height:120px;overflow:auto}.autocomplete-result{list-style:none;text-align:left;padding:4px 2px;cursor:pointer}.autocomplete-result:hover{background-color:#4aae9b;color:#fff}", ""]);

// exports


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("shopping_cart")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"id":_vm.placeholder.replace(/\s/g, ''),"type":"text","autocomplete":"off"},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},_vm.onChange]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.placeholder.replace(/\s/g, '')}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"autocomplete-results"},_vm._l((_vm.results),function(result,i){return _c('li',{key:i,staticClass:"autocomplete-result",on:{"click":function($event){return _vm.setResult(result)}}},[_vm._v("\n                      "+_vm._s(result.label)+"\n                  ")])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VMoney=t():e.VMoney=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=9)}([function(e,t,n){"use strict";t.a={prefix:"",suffix:"",thousands:",",decimal:".",precision:2}},function(e,t,n){"use strict";var r=n(2),i=n(5),u=n(0);t.a=function(e,t){if(t.value){var o=n.i(i.a)(u.a,t.value);if("INPUT"!==e.tagName.toLocaleUpperCase()){var a=e.getElementsByTagName("input");1!==a.length||(e=a[0])}e.oninput=function(){var t=e.value.length-e.selectionEnd;e.value=n.i(r.a)(e.value,o),t=Math.max(t,o.suffix.length),t=e.value.length-t,t=Math.max(t,o.prefix.length+1),n.i(r.b)(e,t),e.dispatchEvent(n.i(r.c)("change"))},e.onfocus=function(){n.i(r.b)(e,e.value.length-o.suffix.length)},e.oninput(),e.dispatchEvent(n.i(r.c)("input"))}}},function(e,t,n){"use strict";function r(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:m.a;"number"==typeof e&&(e=e.toFixed(o(t.precision)));var n=e.indexOf("-")>=0?"-":"",r=u(e),i=c(r,t.precision),a=d(i).split("."),p=a[0],l=a[1];return p=f(p,t.thousands),t.prefix+n+s(p,l,t.decimal)+t.suffix}function i(e,t){var n=e.indexOf("-")>=0?-1:1,r=u(e),i=c(r,t);return parseFloat(i)*n}function u(e){return d(e).replace(/\D+/g,"")||"0"}function o(e){return a(0,e,20)}function a(e,t,n){return Math.max(e,Math.min(t,n))}function c(e,t){var n=Math.pow(10,t);return(parseFloat(e)/n).toFixed(o(t))}function f(e,t){return e.replace(/(\d)(?=(?:\d{3})+\b)/gm,"$1"+t)}function s(e,t,n){return t?e+n+t:e}function d(e){return e?e.toString():""}function p(e,t){var n=function(){e.setSelectionRange(t,t)};e===document.activeElement&&(n(),setTimeout(n,1))}function l(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var m=n(0);n.d(t,"a",function(){return r}),n.d(t,"d",function(){return i}),n.d(t,"b",function(){return p}),n.d(t,"c",function(){return l})},function(e,t,n){"use strict";function r(e,t){t&&Object.keys(t).map(function(e){a.a[e]=t[e]}),e.directive("money",o.a),e.component("money",u.a)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),u=n.n(i),o=n(1),a=n(0);n.d(t,"Money",function(){return u.a}),n.d(t,"VMoney",function(){return o.a}),n.d(t,"options",function(){return a.a}),n.d(t,"VERSION",function(){return c});var c="0.8.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),i=n(0),u=n(2);t.default={name:"Money",props:{value:{required:!0,type:[Number,String],default:0},masked:{type:Boolean,default:!1},precision:{type:Number,default:function(){return i.a.precision}},decimal:{type:String,default:function(){return i.a.decimal}},thousands:{type:String,default:function(){return i.a.thousands}},prefix:{type:String,default:function(){return i.a.prefix}},suffix:{type:String,default:function(){return i.a.suffix}}},directives:{money:r.a},data:function(){return{formattedValue:""}},watch:{value:{immediate:!0,handler:function(e,t){var r=n.i(u.a)(e,this.$props);r!==this.formattedValue&&(this.formattedValue=r)}}},methods:{change:function(e){this.$emit("input",this.masked?e.target.value:n.i(u.d)(e.target.value,this.precision))}}}},function(e,t,n){"use strict";t.a=function(e,t){return e=e||{},t=t||{},Object.keys(e).concat(Object.keys(t)).reduce(function(n,r){return n[r]=void 0===t[r]?e[r]:t[r],n},{})}},function(e,t,n){var r=n(7)(n(4),n(8),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var i,u=e=e||{},o=typeof e.default;"object"!==o&&"function"!==o||(i=e,u=e.default);var a="function"==typeof u?u.options:u;if(t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns),n&&(a._scopeId=n),r){var c=a.computed||(a.computed={});Object.keys(r).forEach(function(e){var t=r[e];c[e]=function(){return t}})}return{esModule:i,exports:u,options:a}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"money",rawName:"v-money",value:{precision:e.precision,decimal:e.decimal,thousands:e.thousands,prefix:e.prefix,suffix:e.suffix},expression:"{precision, decimal, thousands, prefix, suffix}"}],staticClass:"v-money",attrs:{type:"tel"},domProps:{value:e.formattedValue},on:{change:e.change}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-circular-new',{attrs:{"pagetitle":"Produtos","step":2,"title":"Escolha os produtos","subtitle":"Escolha os produtos que irá utilizar para criar sua nova circular."}},[_vm._l((_vm.qtd_itens),function(i){return _c('div',{key:i,staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"card-panel grey lighten-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('autocomplete',{attrs:{"placeholder":'Produto ' + i,"items":_vm.products},on:{"selected":function (item) { return _vm.itemSelected(item, i); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field"},[_c('money',_vm._b({attrs:{"id":'sight_price_' + i,"placeholder":_vm.products_to_send[i].sight_price},model:{value:(_vm.products_to_send[i].sight_price),callback:function ($$v) {_vm.$set(_vm.products_to_send[i], "sight_price", $$v)},expression:"products_to_send[i].sight_price"}},'money',_vm.money,false)),_vm._v(" "),_c('label',{attrs:{"for":'sight_price' + i}},[_vm._v("Preço à vista")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Preço à vista do produto")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field"},[_c('money',_vm._b({attrs:{"id":'forward_price_'+ i},on:{"input":function () { return _vm.calculatePaymentPrice(i); }},model:{value:(_vm.products_to_send[i].forward_price),callback:function ($$v) {_vm.$set(_vm.products_to_send[i], "forward_price", $$v)},expression:"products_to_send[i].forward_price"}},'money',_vm.money,false)),_vm._v(" "),_c('label',{attrs:{"for":'forward_price_'+ i}},[_vm._v("Preço à prazo")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Preço à prazo do produto")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.products_to_send[i].payment_x),expression:"products_to_send[i].payment_x"}],attrs:{"id":'payment_x_'+ i,"type":"text"},domProps:{"value":(_vm.products_to_send[i].payment_x)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.products_to_send[i], "payment_x", $event.target.value)},function () { return _vm.calculatePaymentPrice(i); }]}}),_vm._v(" "),_c('label',{attrs:{"for":'payment_x_'+ i}},[_vm._v("Qtd. Parcelas")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Quantidade de parcelas para pagamento")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field"},[_c('money',_vm._b({attrs:{"id":'payment_price_'+ i},model:{value:(_vm.products_to_send[i].payment_price),callback:function ($$v) {_vm.$set(_vm.products_to_send[i], "payment_price", $$v)},expression:"products_to_send[i].payment_price"}},'money',_vm.money,false)),_vm._v(" "),_c('label',{attrs:{"for":'payment_price_'+ i}},[_vm._v("Valor da Parcela")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Valor a ser pago por cada parcela")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.products_to_send[i].without_entrance),expression:"products_to_send[i].without_entrance"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.products_to_send[i].without_entrance)?_vm._i(_vm.products_to_send[i].without_entrance,null)>-1:(_vm.products_to_send[i].without_entrance)},on:{"change":function($event){var $$a=_vm.products_to_send[i].without_entrance,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.products_to_send[i], "without_entrance", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.products_to_send[i], "without_entrance", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.products_to_send[i], "without_entrance", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Sem entrada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.products_to_send[i].without_interest),expression:"products_to_send[i].without_interest"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.products_to_send[i].without_interest)?_vm._i(_vm.products_to_send[i].without_interest,null)>-1:(_vm.products_to_send[i].without_interest)},on:{"change":[function($event){var $$a=_vm.products_to_send[i].without_interest,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.products_to_send[i], "without_interest", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.products_to_send[i], "without_interest", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.products_to_send[i], "without_interest", $$c)}},function($event){return _vm.calculateWithoutInterest($event, i)}]}}),_vm._v(" "),_c('span',[_vm._v("Sem juros")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.products_to_send[i].in_carne),expression:"products_to_send[i].in_carne"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.products_to_send[i].in_carne)?_vm._i(_vm.products_to_send[i].in_carne,null)>-1:(_vm.products_to_send[i].in_carne)},on:{"change":function($event){var $$a=_vm.products_to_send[i].in_carne,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.products_to_send[i], "in_carne", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.products_to_send[i], "in_carne", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.products_to_send[i], "in_carne", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("No carnê")])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.products_to_send[i].in_card),expression:"products_to_send[i].in_card"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.products_to_send[i].in_card)?_vm._i(_vm.products_to_send[i].in_card,null)>-1:(_vm.products_to_send[i].in_card)},on:{"change":function($event){var $$a=_vm.products_to_send[i].in_card,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.products_to_send[i], "in_card", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.products_to_send[i], "in_card", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.products_to_send[i], "in_card", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("No cartão")])])])])])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",on:{"click":_vm.nextStep}},[_vm._v("Próximo!")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceOptions_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf7176e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceOptions_vue__ = __webpack_require__(105);
function injectStyle (ssrContext) {
  __webpack_require__(100)
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bf7176e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChoiceOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf7176e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChoiceOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a946a264", content, true, {});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("558df64c", content, true, {});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".multiselect__content-wrapper [data-v-1bf7176e]{position:relative;z-index:6}.multiselect--active[data-v-1bf7176e]{z-index:10}", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-circular-new',{attrs:{"pagetitle":"Dados Tablóide","step":3,"title":"Preencha dados do tablóide","subtitle":"Preencha os dados necessários para gerar o tablóide"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"card-panel grey lighten-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chamada),expression:"chamada"}],attrs:{"id":"chamada","type":"text","maxlength":"50"},domProps:{"value":(_vm.chamada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chamada=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"chamada"}},[_vm._v("Texto de Chamada")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Texto de chamada à ser colocado no topo do tablóide.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Cidades de Abrangência")]),_vm._v(" "),_c('multiselect',{attrs:{"label":"nome","track-by":"id","multiple":true,"close-on-select":false,"options":_vm.cities,"placeholder":'Selecione uma ou mais cidades'},model:{value:(_vm.abrangencia),callback:function ($$v) {_vm.abrangencia=$$v},expression:"abrangencia"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Tema")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.theme),expression:"theme"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.theme=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Escolha um item")]),_vm._v(" "),_c('option',{attrs:{"value":"vqt"}},[_vm._v("Vem que tem")]),_vm._v(" "),_c('option',{attrs:{"value":"dga"}},[_vm._v("Dia de Gazin")]),_vm._v(" "),_c('option',{attrs:{"value":"ang"}},[_vm._v("Aniversário Gazin")]),_vm._v(" "),_c('option',{attrs:{"value":"oug"}},[_vm._v("Outlet Gazin")]),_vm._v(" "),_c('option',{attrs:{"value":"mgf"}},[_vm._v("Atacado Gazin Seleção de Ofertas")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Banner")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.banner),expression:"banner"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.banner=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Escolha um item")]),_vm._v(" "),_c('option',{attrs:{"value":"placa_compra_inteligente"}},[_vm._v("VEMQTEM")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Cor de Fundo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.background_color),expression:"background_color"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.background_color=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Escolha um item")]),_vm._v(" "),_c('option',{attrs:{"value":"#FFFFFF"}},[_vm._v("Branco")]),_vm._v(" "),_c('option',{attrs:{"value":"#d6c3d9"}},[_vm._v("Roxo")]),_vm._v(" "),_c('option',{attrs:{"value":"#cad9d6"}},[_vm._v("Verde")]),_vm._v(" "),_c('option',{attrs:{"value":"#fffcd5"}},[_vm._v("Amarelo")]),_vm._v(" "),_c('option',{attrs:{"value":"#e1eefb"}},[_vm._v("Azul")]),_vm._v(" "),_c('option',{attrs:{"value":"#e0a6b2"}},[_vm._v("Nude")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dtinicio),expression:"dtinicio"}],attrs:{"id":"data_inicio","type":"date","placeholder":"Data de Início"},domProps:{"value":(_vm.dtinicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dtinicio=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"data_inicio"}},[_vm._v("Data de Início")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Data de ínicio da validade do tablóide.")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dtfim),expression:"dtfim"}],attrs:{"id":"data_termino","type":"date","placeholder":"Data de Término"},domProps:{"value":(_vm.dtfim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dtfim=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"data_termino"}},[_vm._v("Data de Término")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Data de término da validade do tablóide.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",on:{"click":_vm.generateCircular}},[_vm._v("Gerar!")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircularList_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0d5256_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircularList_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a0d5256"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircularList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0d5256_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircularList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6d21b55c", content, true, {});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main[data-v-9a0d5256]{padding-left:240px}", ""]);

// exports


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-theme',{attrs:{"breadcrumb":this.breads}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"highlight"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.id},[_c('td',[_vm._v(_vm._s(row.data))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qtd_itens))]),_vm._v(" "),_vm._m(1,true)])}),0),_vm._v(" "),_c('tfoot',{staticClass:"grey lighten-3"},[_c('tr',[_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.rows.map(function (el) { return el.qtd_itens; }).reduce(function (accumulator, currentValue) { return Number(accumulator) + Number(currentValue); })))]),_vm._v(" "),_c('td')])])])])])]),_vm._v(" "),_c('side-menu')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Qtd Itens")]),_vm._v(" "),_c('th',[_vm._v("Opções")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{attrs:{"href":""}},[_c('i',{staticClass:"blue-text text-lighten-1 material-icons"},[_vm._v("edit")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate2x_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d8f51a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate2x_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate2x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d8f51a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate2x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("27165f2e", content, true, {});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:330px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:480px;height:300px;position:absolute;top:885px;left:1150px}#container-price-theme-23-2{width:480px;height:300px;position:absolute;top:1795px;left:345px}#img1-container{width:700px;top:510px;height:800px;left:160px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{top:546px;left:1120px;font-size:44px;text-transform:uppercase;font-weight:900;width:400px;height:130px}#carac-1,#titulo-1{color:#151515;text-align:right}#carac-1{position:absolute;top:705px;left:1115px;font-size:28px;width:412px;height:166px;overflow:hidden}#container-price-1{border:4px solid #151515;border-radius:55px;width:450px;position:absolute;top:925px;left:1070px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:42px;margin:0;margin-left:50px}#container-price-1 #preco-prazo-1{font-size:28px;margin:0;margin-left:70px}#container-price-1 #price-parcela-1{font-size:100px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:70px;font-weight:900}#container-price-1 #parcelas-1,#container-price-1 #prefix-1{padding:0;margin:0;font-size:32px;line-height:1;margin-left:58px;margin-top:10px}#container-price-1 #prefix-1{color:#fa7b19}#img2-container{position:absolute;top:1320px;left:900px;width:700px;height:1000px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-2{top:1446px;left:240px;font-size:44px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;text-align:right;overflow:hidden}#carac-2{top:1605px;left:265px;font-size:28px;width:412px;height:166px}#container-price-2{border:4px solid #151515;border-radius:55px;width:450px;position:absolute;top:1825px;left:215px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:42px;margin:0;margin-left:50px}#container-price-2 #preco-prazo-2{font-size:28px;margin:0;margin-left:70px}#container-price-2 #price-parcela-2{font-size:100px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:70px;font-weight:900}#container-price-2 #parcelas-2,#container-price-2 #prefix-2{padding:0;margin:0;font-size:32px;line-height:1;margin-left:58px;margin-top:10px}#container-price-2 #prefix-2{color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"options-buy-1"}},[_vm._v(_vm._s(_vm.product_1.options_buy))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"options-buy-2"}},[_vm._v(_vm._s(_vm.product_2.options_buy))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1_placa_compra_inteligente.png?c72db37745487b45dcf442bf6665fab7";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1_rodapenov_.png?2d4e8c8e4015881b33f8d56fa5ef7439";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_placa_compra_inteligente.png?28846adfc607a68ba74fb9dddf235080";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_rodapenov.png?b2a36ce4300db5e9f035bd63eb19ece8";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_ar_10x_s_1x9_carne.png?8f5ef5c9cfadc637d01fe467a04971d2";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_ar_10x_s_entr_s_juros.png?ff8f24c9a2fedd3cff8af55b34c0f4d5";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_col_estof_10x_s_1x9_carne.png?daa8f041af00062babf313fe6f47036a";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_col_estof_10x_s_entr_s_juros.png?0e5079805f3aaefbb0bf59a6d1c4e928";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_compra_inteligente.png?fa9c61cf481ff28d63a8429e245a364f";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_infor_10x_s_1x9_carne.png?3b3043c4648df9db6a37cf3dff9495a2";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_infor_10x_s_entr_s_juros.png?f4aa00ab70bb34e46d3b4c1177463f8c";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_mov_10x_s_1x9_carne.png?b422e69075a01d7456bd9f013d0e5e49";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_mov_10x_s_entr_s_juros.png?901c076ee238790ea72f19a784fb7faf";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_moveis_10x_s_1x9_carne.png?e88e90b75b9aac6745726346e0b5fc80";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_moveis_10x_s_entr_s_juros.png?499bea87b0370c0ca31ff073215a7a40";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_smart_10x_s_1x9_carne.png?46b33148d310ba57e8463aaed1c68b9d";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_smart_10x_s_entr_s_juros.png?3b26522c49b1adfd1044f54c8afab142";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_td_loja_s_entr_s_juros.png?b422e69075a01d7456bd9f013d0e5e49";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_td_loja_s_juros_0x12_catao.png?2237200b59eb0bb92f3a7bcab7214c2c";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_td_loja_s_juros_1x9_carne.png?872d46d622ebfb7ba51e9d81224f9ea6";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_td_loja_s_juros_carne.png?cdf60f4a600d520d0b65107de78c0f71";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "placa_td_loja_s_juros_cartoes.png?50e83218dcdad13a3f1eb65fef8d266e";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rodapenov.png?656354b9a5be98186667a24d22c98f63";

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate3x_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c817ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate3x_vue__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate3x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c817ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate3x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(139);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6c45576b", content, true, {});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:480px;height:300px;position:absolute;top:885px;left:1150px}#container-price-theme-23-2{width:480px;height:300px;position:absolute;top:1795px;left:485px}#container-price-theme-23-3{width:480px;height:300px;position:absolute;top:1795px;left:1325px}#img1-container{width:1000px;top:490px;height:800px;left:30px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{top:546px;left:1120px;font-size:44px;text-transform:uppercase;font-weight:900;width:400px;height:130px}#carac-1,#titulo-1{color:#151515;text-align:right}#carac-1{position:absolute;top:705px;left:1115px;font-size:28px;width:412px;height:150px;overflow:hidden}#container-price-1{border:4px solid #151515;border-radius:55px;width:450px;position:absolute;top:925px;left:1070px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:42px;margin:0;margin-left:50px}#container-price-1 #preco-prazo-1{font-size:28px;margin:0;margin-left:70px}#container-price-1 #price-parcela-1{font-size:100px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:70px;font-weight:900}#container-price-1 #parcelas-1,#container-price-1 #prefix-1{padding:0;margin:0;font-size:32px;line-height:1;margin-left:58px;margin-top:10px}#container-price-1 #prefix-1{color:#fa7b19}#img2-container{position:absolute;top:1320px;left:50px;width:400px;height:1000px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-2{top:1515px;left:410px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;text-align:right;overflow:hidden}#carac-2{top:1625px;left:430px;font-size:24px;width:412px;height:150px}#container-price-2{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:1805px;left:475px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-2 #preco-prazo-2{font-size:24px;margin:0;margin-left:50px}#container-price-2 #price-parcela-2{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:90px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-2 #parcelas-2,#container-price-2 #prefix-2{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-2 #prefix-2{color:#fa7b19}#img3-container{position:absolute;top:1320px;left:900px;width:400px;height:1000px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1515px;left:1290px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;text-align:right;overflow:hidden}#carac-3{top:1625px;left:1325px;font-size:24px;width:392px;height:150px}#container-price-3{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:1805px;left:1345px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-3 #preco-prazo-3{font-size:24px;margin:0;margin-left:50px}#container-price-3 #price-parcela-3{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:90px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-3 #parcelas-3,#container-price-3 #prefix-3{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-3 #prefix-3{color:#fa7b19}", ""]);

// exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate4x_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24645b38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate4x_vue__ = __webpack_require__(144);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate4x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24645b38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate4x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2cb12f12", content, true, {});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:1095px;left:225px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:1095px;left:1365px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:1795px;left:485px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:1795px;left:1325px}#img1-container{width:400px;top:480px;height:650px;left:50px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{top:546px;font-size:34px;text-transform:uppercase;font-weight:900;width:360px;height:130px}#carac-1,#titulo-1{color:#151515;left:610px;text-align:left}#carac-1{position:absolute;top:655px;font-size:24px;width:260px;height:150px;overflow:hidden}#container-price-1{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:835px;left:470px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-1 #preco-prazo-1{font-size:24px;margin:0;margin-left:50px}#container-price-1 #price-parcela-1{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:55px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-1 #parcelas-1,#container-price-1 #prefix-1{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-1 #prefix-1{color:#fa7b19}#img2-container{width:400px;position:absolute;top:580px;height:650px;overflow:hidden;left:900px;display:flex;align-items:center;justify-content:center}#titulo-2{top:546px;font-size:34px;text-transform:uppercase;font-weight:900;width:400px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;left:1450px;text-align:left;overflow:hidden}#carac-2{top:655px;font-size:24px;width:412px;height:150px}#container-price-2{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:835px;left:1355px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-2 #preco-prazo-2{font-size:24px;margin:0;margin-left:50px}#container-price-2 #price-parcela-2{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:55px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-2 #parcelas-2,#container-price-2 #prefix-2{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-2 #prefix-2{color:#fa7b19}#img3-container{position:absolute;top:1450px;left:50px;width:400px;height:650px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1515px;font-size:34px;text-transform:uppercase;font-weight:900;width:440px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;left:490px;text-align:left;overflow:hidden}#carac-3{top:1625px;font-size:24px;width:412px;height:166px}#container-price-3{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:1805px;left:465px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-3 #preco-prazo-3{font-size:24px;margin:0;margin-left:50px}#container-price-3 #price-parcela-3{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:55px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-3 #parcelas-3,#container-price-3 #prefix-3{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-3 #prefix-3{color:#fa7b19}#img4-container{position:absolute;top:1450px;left:920px;width:400px;height:650px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:1515px;font-size:34px;text-transform:uppercase;font-weight:900;width:440px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;left:1330px;text-align:left;overflow:hidden}#carac-4{top:1625px;font-size:24px;width:392px;height:166px}#container-price-4{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:1805px;left:1355px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-4 #preco-prazo-4{font-size:24px;margin:0;margin-left:50px}#container-price-4 #price-parcela-4{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:55px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-4 #parcelas-4,#container-price-4 #prefix-4{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-4 #prefix-4{color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"98px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"98px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"98px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"98px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate5x_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa5a062_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate5x_vue__ = __webpack_require__(148);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate5x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa5a062_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate5x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a8d16416", content, true, {});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:835px;left:455px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:835px;left:1305px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:2045px;left:135px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:2045px;left:725px}#container-price-theme-23-5{width:380px;height:300px;position:absolute;top:2045px;left:1305px}#img1-container{width:400px;top:500px;height:630px;left:50px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{top:546px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-1,#titulo-1{color:#151515;left:460px;text-align:left}#carac-1{position:absolute;top:655px;font-size:24px;width:412px;height:150px;overflow:hidden}#container-price-1{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:835px;left:475px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-1 #preco-prazo-1{font-size:24px;margin:0;margin-left:50px}#container-price-1 #price-parcela-1{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-1 #parcelas-1,#container-price-1 #prefix-1{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-1 #prefix-1{color:#fa7b19}#img2-container{width:400px;position:absolute;top:580px;height:550px;overflow:hidden;left:900px;display:flex;align-items:center;justify-content:center}#titulo-2{top:546px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;left:1300px;text-align:left;overflow:hidden}#carac-2{top:655px;font-size:24px;width:412px;height:150px}#container-price-2{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:835px;left:1355px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-2 #preco-prazo-2{font-size:24px;margin:0;margin-left:50px}#container-price-2 #price-parcela-2{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-2 #parcelas-2,#container-price-2 #prefix-2{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-2 #prefix-2{color:#fa7b19}#img3-container{position:absolute;top:1260px;left:70px;width:480px;height:650px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1915px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;overflow:hidden}#carac-3{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:150px;display:none}#container-price-3{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:2045px;left:155px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-3 #preco-prazo-3{font-size:22px;margin:0;margin-left:24px}#container-price-3 #price-parcela-3{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-3 #parcelas-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-3 #prefix-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img4-container{position:absolute;top:1260px;left:660px;width:480px;height:650px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:1915px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;overflow:hidden}#carac-4{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:150px;display:none}#container-price-4{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:2045px;left:750px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-4 #preco-prazo-4{font-size:22px;margin:0;margin-left:24px}#container-price-4 #price-parcela-4{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-4 #parcelas-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-4 #prefix-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img5-container{position:absolute;top:1260px;left:1240px;width:480px;height:650px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-5{top:1915px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-5,#titulo-5{color:#151515;position:absolute;overflow:hidden}#carac-5{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:150px;display:none}#container-price-5{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:2045px;left:1340px;padding:10px 0}#container-price-5 #values-5{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-5 #preco-prazo-5{font-size:22px;margin:0;margin-left:24px}#container-price-5 #price-parcela-5{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-5 #price-parcela-5 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-5 #parcelas-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-5 #prefix-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"114px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"114px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"154px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"154px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img5-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_5.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-5"}},[_c('p',{attrs:{"id":"values-5"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_5.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"110px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-5"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-5"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-5"}},[_vm._v("\n                        "+_vm._s(_vm.product_5.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_5.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-5"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_5.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-5"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"154px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_5.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_5.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_5.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_5.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_5.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate6x_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bd4a4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate6x_vue__ = __webpack_require__(152);
function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate6x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bd4a4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate6x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(151);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("728e502e", content, true, {});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:1185px;left:135px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:1185px;left:725px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:1185px;left:1315px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:2125px;left:135px}#container-price-theme-23-5{width:380px;height:300px;position:absolute;top:2125px;left:725px}#container-price-theme-23-6{width:380px;height:300px;position:absolute;top:2125px;left:1315px}#img1-container{top:530px;left:70px;width:480px;height:580px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{color:#151515;top:1075px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-1{color:#151515;position:absolute;top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;overflow:hidden;display:none}#container-price-1{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1205px;left:145px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-1 #preco-prazo-1{font-size:22px;margin:0;margin-left:24px}#container-price-1 #price-parcela-1{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-1 #parcelas-1{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-1 #prefix-1{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img2-container{position:absolute;top:550px;left:660px;width:480px;height:560px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-2{top:1075px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;overflow:hidden}#carac-2{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-2{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:1205px;left:750px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-2 #preco-prazo-2{font-size:22px;margin:0;margin-left:24px}#container-price-2 #price-parcela-2{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-2 #parcelas-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-2 #prefix-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img3-container{position:absolute;top:570px;left:1240px;width:480px;height:530px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1075px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;overflow:hidden}#carac-3{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-3{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1205px;left:1330px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-3 #preco-prazo-3{font-size:22px;margin:0;margin-left:24px}#container-price-3 #price-parcela-3{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-3 #parcelas-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-3 #prefix-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img4-container{position:absolute;top:1430px;left:70px;width:480px;height:570px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:2015px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;overflow:hidden}#carac-4{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-4{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:2145px;left:145px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-4 #preco-prazo-4{font-size:22px;margin:0;margin-left:24px}#container-price-4 #price-parcela-4{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-4 #parcelas-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-4 #prefix-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img5-container{position:absolute;top:1430px;left:660px;width:480px;height:570px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-5{top:2015px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-5,#titulo-5{color:#151515;position:absolute;overflow:hidden}#carac-5{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-5{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:2145px;left:740px;padding:10px 0}#container-price-5 #values-5{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-5 #preco-prazo-5{font-size:22px;margin:0;margin-left:24px}#container-price-5 #price-parcela-5{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-5 #price-parcela-5 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-5 #parcelas-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-5 #prefix-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img6-container{position:absolute;top:1430px;left:1240px;width:480px;height:570px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-6{top:2015px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-6,#titulo-6{color:#151515;position:absolute;overflow:hidden}#carac-6{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-6{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:2145px;left:1330px;padding:10px 0}#container-price-6 #values-6{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-6 #preco-prazo-6{font-size:22px;margin:0;margin-left:24px}#container-price-6 #price-parcela-6{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-6 #price-parcela-6 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-6 #parcelas-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-6 #prefix-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"32px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"32px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"32px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"28px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img5-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_5.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-5"}},[_c('p',{attrs:{"id":"values-5"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_5.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-5"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-5"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-5"}},[_vm._v("\n                        "+_vm._s(_vm.product_5.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_5.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-5"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_5.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-5"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_5.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_5.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_5.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"28px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_5.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_5.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img6-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_6.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-6"}},[_c('p',{attrs:{"id":"values-6"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_6.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"80px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-6"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-6"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-6"}},[_vm._v("\n                        "+_vm._s(_vm.product_6.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_6.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-6"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_6.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-6"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_6.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_6.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_6.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"28px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_6.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_6.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate7x_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2a1f78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate7x_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate7x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2a1f78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate7x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4304a350", content, true, {});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:685px;left:855px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:1495px;left:125px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:1495px;left:725px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:1495px;left:1335px}#container-price-theme-23-5{width:380px;height:300px;position:absolute;top:2160px;left:135px}#container-price-theme-23-6{width:380px;height:300px;position:absolute;top:2160px;left:725px}#container-price-theme-23-7{width:380px;height:300px;position:absolute;top:2160px;left:1315px}.titulo_1_tema_23{top:510px!important;left:765px!important}#teo{position:absolute;height:600px;top:400px;left:1360px}#img1-container{width:680px;top:500px;height:500px;left:70px;display:flex;align-items:center;justify-content:center}#img1-container,#titulo-1{position:absolute;overflow:hidden}#titulo-1{top:426px;left:1120px;font-size:44px;text-transform:uppercase;font-weight:900;width:400px;height:130px}#carac-1,#titulo-1{color:#151515;text-align:right}#carac-1{position:absolute;top:570px;left:1115px;font-size:28px;width:412px;height:166px;overflow:hidden;display:none}#container-price-1{border:4px solid #151515;border-radius:55px;width:390px;position:absolute;top:775px;left:1125px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:38px;margin:0;margin-left:40px}#container-price-1 #preco-prazo-1{font-size:26px;margin:0;margin-left:50px}#container-price-1 #price-parcela-1{font-size:90px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:70px;font-weight:900}#container-price-1 #parcelas-1{padding:0;margin:0;font-size:30px;line-height:1;margin-left:48px;margin-top:10px}#container-price-1 #prefix-1{padding:0;margin:0;font-size:30px;line-height:1;margin-left:55px;margin-top:10px;color:#fa7b19}#img2-container{position:absolute;top:1010px;left:70px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-2{top:1385px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;overflow:hidden}#carac-2{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-2{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1505px;left:145px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-2 #preco-prazo-2{font-size:22px;margin:0;margin-left:24px}#container-price-2 #price-parcela-2{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-2 #parcelas-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-2 #prefix-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img3-container{position:absolute;top:1010px;left:660px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1385px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;overflow:hidden}#carac-3{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-3{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:1505px;left:750px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-3 #preco-prazo-3{font-size:22px;margin:0;margin-left:24px}#container-price-3 #price-parcela-3{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-3 #parcelas-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-3 #prefix-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img4-container{position:absolute;top:1010px;left:1250px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:1385px;left:1285px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;overflow:hidden}#carac-4{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-4{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1505px;left:1340px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-4 #preco-prazo-4{font-size:22px;margin:0;margin-left:24px}#container-price-4 #price-parcela-4{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-4 #parcelas-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-4 #prefix-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img5-container{position:absolute;top:1680px;left:70px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-5{top:2050px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-5,#titulo-5{color:#151515;position:absolute;overflow:hidden}#carac-5{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-5{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2165px;left:145px;padding:10px 0}#container-price-5 #values-5{color:#151515;font-size:24px;margin:0;margin-left:50px}#container-price-5 #preco-prazo-5{font-size:24px;margin:0;margin-left:24px}#container-price-5 #price-parcela-5{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-5 #price-parcela-5 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-5 #parcelas-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-5 #prefix-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img6-container{position:absolute;top:1680px;left:660px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-6{top:2050px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-6,#titulo-6{color:#151515;position:absolute;overflow:hidden}#carac-6{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-6{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2165px;left:740px;padding:10px 0}#container-price-6 #values-6{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-6 #preco-prazo-6{font-size:24px;margin:0;margin-left:24px}#container-price-6 #price-parcela-6{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-6 #price-parcela-6 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-6 #parcelas-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-6 #prefix-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img7-container{position:absolute;top:1680px;left:1250px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-7{top:2050px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-7,#titulo-7{color:#151515;position:absolute;overflow:hidden}#carac-7{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-7{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2165px;left:1330px;padding:10px 0}#container-price-7 #values-7{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-7 #preco-prazo-7{font-size:24px;margin:0;margin-left:24px}#container-price-7 #price-parcela-7{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-7 #price-parcela-7 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-7 #parcelas-7{padding:0;margin:0;font-size:20px;line-height:1;margin-left:38px;margin-top:10px}#container-price-7 #prefix-7{padding:0;margin:0;font-size:20px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{class:{ titulo_1_tema_23: (this.theme != 'vqt') },attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"src":"https://circular.rxy.com.br/api/public/imgs/00000_face.png","id":"teo","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"38px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"32px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"18px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img5-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_5.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-5"}},[_c('p',{attrs:{"id":"values-5"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_5.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-5"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-5"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-5"}},[_vm._v("\n                        "+_vm._s(_vm.product_5.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_5.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-5"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_5.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-5"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_5.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_5.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_5.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_5.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_5.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img6-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_6.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-6"}},[_c('p',{attrs:{"id":"values-6"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_6.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-6"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-6"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-6"}},[_vm._v("\n                        "+_vm._s(_vm.product_6.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_6.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-6"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_6.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-6"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_6.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_6.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_6.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_6.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_6.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img7-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_7.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-7"}},[_c('p',{attrs:{"id":"values-7"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_7.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-7"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-7"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-7"}},[_vm._v("\n                        "+_vm._s(_vm.product_7.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_7.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-7"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_7.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-7"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_7.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_7.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_7.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_7.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_7.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate8x_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f1c708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate8x_vue__ = __webpack_require__(160);
function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate8x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f1c708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate8x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e1c0e700", content, true, {});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:715px;left:465px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:715px;left:1345px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:1495px;left:125px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:1495px;left:725px}#container-price-theme-23-5{width:380px;height:300px;position:absolute;top:1495px;left:1335px}#container-price-theme-23-6{width:380px;height:300px;position:absolute;top:2160px;left:135px}#container-price-theme-23-7{width:380px;height:300px;position:absolute;top:2160px;left:725px}#container-price-theme-23-8{width:380px;height:300px;position:absolute;top:2160px;left:1315px}.titulo_1_tema_23{top:510px!important}#img1-container{width:400px;position:absolute;top:490px;height:450px;overflow:hidden;left:50px;display:flex;align-items:center;justify-content:center}#titulo-1{top:456px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-1,#titulo-1{color:#151515;position:absolute;left:470px;text-align:left;overflow:hidden}#carac-1{top:575px;font-size:24px;width:412px;height:166px}#container-price-1{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:750px;left:465px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-1 #preco-prazo-1{font-size:24px;margin:0;margin-left:50px}#container-price-1 #price-parcela-1{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-1 #parcelas-1,#container-price-1 #prefix-1{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-1 #prefix-1{color:#fa7b19}#img2-container{width:400px;position:absolute;top:490px;height:450px;overflow:hidden;left:900px;display:flex;align-items:center;justify-content:center}#titulo-2{top:456px;font-size:34px;text-transform:uppercase;font-weight:900;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;left:1350px;text-align:left;overflow:hidden}#carac-2{top:575px;font-size:24px;width:412px;height:166px}#container-price-2{border:4px solid #151515;border-radius:55px;width:370px;position:absolute;top:750px;left:1345px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:32px;margin:0;margin-left:50px}#container-price-2 #preco-prazo-2{font-size:24px;margin:0;margin-left:50px}#container-price-2 #price-parcela-2{font-size:76px;margin:0;color:#fa7b19;line-height:1;margin-left:50px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:36px;margin:0;color:#fa7b19;position:absolute;top:60px;font-weight:900}#container-price-2 #parcelas-2,#container-price-2 #prefix-2{padding:0;margin:0;font-size:28px;line-height:1;margin-left:58px;margin-top:10px}#container-price-2 #prefix-2{color:#fa7b19}#img3-container{position:absolute;top:1010px;left:70px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:1385px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;overflow:hidden}#carac-3{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-3{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1505px;left:145px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-3 #preco-prazo-3{font-size:22px;margin:0;margin-left:24px}#container-price-3 #price-parcela-3{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-3 #parcelas-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-3 #prefix-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img4-container{position:absolute;top:1010px;left:660px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:1385px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;overflow:hidden}#carac-4{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-4{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:1505px;left:750px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-4 #preco-prazo-4{font-size:22px;margin:0;margin-left:24px}#container-price-4 #price-parcela-4{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-4 #parcelas-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-4 #prefix-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img5-container{position:absolute;top:1010px;left:1250px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-5{top:1385px;left:1285px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-5,#titulo-5{color:#151515;position:absolute;overflow:hidden}#carac-5{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-5{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1505px;left:1340px;padding:10px 0}#container-price-5 #values-5{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-5 #preco-prazo-5{font-size:22px;margin:0;margin-left:24px}#container-price-5 #price-parcela-5{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-5 #price-parcela-5 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-5 #parcelas-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-5 #prefix-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img6-container{position:absolute;top:1680px;left:70px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-6{top:2045px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-6,#titulo-6{color:#151515;position:absolute;overflow:hidden}#carac-6{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-6{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:145px;padding:10px 0}#container-price-6 #values-6{color:#151515;font-size:24px;margin:0;margin-left:50px}#container-price-6 #preco-prazo-6{font-size:24px;margin:0;margin-left:24px}#container-price-6 #price-parcela-6{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-6 #price-parcela-6 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-6 #parcelas-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-6 #prefix-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img7-container{position:absolute;top:1680px;left:660px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-7{top:2045px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-7,#titulo-7{color:#151515;position:absolute;overflow:hidden}#carac-7{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-7{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:740px;padding:10px 0}#container-price-7 #values-7{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-7 #preco-prazo-7{font-size:24px;margin:0;margin-left:24px}#container-price-7 #price-parcela-7{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-7 #price-parcela-7 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-7 #parcelas-7{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-7 #prefix-7{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img8-container{position:absolute;top:1680px;left:1250px;width:480px;height:400px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-8{top:2045px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-8,#titulo-8{color:#151515;position:absolute;overflow:hidden}#carac-8{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-8{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:1330px;padding:10px 0}#container-price-8 #values-8{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-8 #preco-prazo-8{font-size:24px;margin:0;margin-left:24px}#container-price-8 #price-parcela-8{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-8 #price-parcela-8 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-8 #parcelas-8{padding:0;margin:0;font-size:20px;line-height:1;margin-left:38px;margin-top:10px}#container-price-8 #prefix-8{padding:0;margin:0;font-size:20px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"20%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"52px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"124px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"22px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img5-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_5.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-5"}},[_c('p',{attrs:{"id":"values-5"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_5.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-5"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-5"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-5"}},[_vm._v("\n                        "+_vm._s(_vm.product_5.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_5.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-5"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_5.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-5"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_5.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_5.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_5.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_5.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_5.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img6-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_6.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-6"}},[_c('p',{attrs:{"id":"values-6"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_6.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-6"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-6"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-6"}},[_vm._v("\n                        "+_vm._s(_vm.product_6.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_6.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-6"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_6.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-6"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_6.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_6.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_6.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_6.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_6.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img7-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_7.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-7"}},[_c('p',{attrs:{"id":"values-7"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_7.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-7"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-7"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-7"}},[_vm._v("\n                        "+_vm._s(_vm.product_7.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_7.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-7"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_7.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-7"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_7.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_7.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_7.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_7.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_7.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img8-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_8.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-8"},domProps:{"innerHTML":_vm._s(_vm.product_8.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-8"},domProps:{"innerHTML":_vm._s(_vm.product_8.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-8"}},[_c('p',{attrs:{"id":"values-8"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_8.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-8"}},[_vm._v(_vm._s(_vm.product_8.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-8"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-8"}},[_vm._v("\n                        "+_vm._s(_vm.product_8.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_8.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-8"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_8.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-8"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_8.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_8.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_8.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_8.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_8.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_8.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate9x_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56dc4107_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate9x_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generate9x_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56dc4107_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generate9x_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("91202676", content, true, {});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(4);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "*{-webkit-print-color-adjust:exact!important;color-adjust:exact!important;font-family:Segoe UI}@font-face{font-family:Segoe UI;font-style:normal;font-weight:400;src:local(\"Segoe UI\"),url(" + escape(__webpack_require__(5)) + ") format(\"woff\")}@font-face{font-family:Segoe UI Bold;font-style:normal;font-weight:700;src:url(" + escape(__webpack_require__(6)) + ") format(\"woff\")}@font-face{font-family:Helvetica Neue LT;font-weight:500;src:url(" + escape(__webpack_require__(7)) + ") format(\"opentype\")}h3#chamada{text-align:left;position:absolute;top:200px;left:60px;font-size:62px;font-family:Helvetica Neue LT;font-weight:500;color:#e00}.html{width:1770px}.body,.html{height:2560px;padding:0;margin:0}.body{background-image:url(" + escape(__webpack_require__(8)) + ");background-size:cover;background-repeat:no-repeat;width:1758px}#banner{width:1770px;position:absolute;top:2344px}.tema-2{background-image:url(" + escape(__webpack_require__(9)) + ")!important}.tema-3{background-image:url(" + escape(__webpack_require__(10)) + ")!important}.tema-4{background-image:url(" + escape(__webpack_require__(11)) + ")!important}.tema-5{background-image:url(" + escape(__webpack_require__(12)) + ")!important}.tema-6{background-image:url(" + escape(__webpack_require__(13)) + ")!important}.chamada-tema-2{top:280px!important;left:90px!important}.chamada-tema-3{top:330px!important;left:60px!important}.tema-2 div[id^=container-price-] p[id^=prefix-],.tema-2 div[id^=container-price-] p[id^=price-parcela-],.tema-2 div[id^=container-price-] p[id^=price-parcela-] small,.tema-3 div[id^=container-price-] p[id^=prefix-],.tema-3 div[id^=container-price-] p[id^=price-parcela-],.tema-3 div[id^=container-price-] p[id^=price-parcela-] small{color:#2c46f6!important}p#options-buy-1{top:885px;left:1120px}p#options-buy-1,p#options-buy-2{position:absolute;text-align:left}p#options-buy-2{top:1785px;left:265px}p.reset{margin:0;padding:0}#container-price-theme-23-1{width:380px;height:300px;position:absolute;top:935px;left:135px}#container-price-theme-23-2{width:380px;height:300px;position:absolute;top:935px;left:725px}#container-price-theme-23-3{width:380px;height:300px;position:absolute;top:935px;left:1315px}#container-price-theme-23-4{width:380px;height:300px;position:absolute;top:1560px;left:135px}#container-price-theme-23-5{width:380px;height:300px;position:absolute;top:1560px;left:725px}#container-price-theme-23-6{width:380px;height:300px;position:absolute;top:1560px;left:1315px}#container-price-theme-23-7{width:380px;height:300px;position:absolute;top:2160px;left:135px}#container-price-theme-23-8{width:380px;height:300px;position:absolute;top:2160px;left:725px}#container-price-theme-23-9{width:380px;height:300px;position:absolute;top:2160px;left:1315px}.img_2_tema_23,.img_3_tema_23{width:480px!important;height:330px!important;top:510px!important}#img1-container{position:absolute;top:510px;left:70px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-1{top:815px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-1,#titulo-1{color:#151515;position:absolute;overflow:hidden}#carac-1{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-1{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:935px;left:155px;padding:10px 0}#container-price-1 #values-1{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-1 #preco-prazo-1{font-size:24px;margin:0;margin-left:12px}#container-price-1 #price-parcela-1{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-1 #price-parcela-1 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-1 #parcelas-1{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-1 #prefix-1{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img2-container{position:absolute;top:610px;left:660px;width:480px;height:230px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-2{top:825px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-2,#titulo-2{color:#151515;position:absolute;overflow:hidden}#carac-2{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-2{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:935px;left:750px;padding:10px 0}#container-price-2 #values-2{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-2 #preco-prazo-2{font-size:22px;margin:0;margin-left:24px}#container-price-2 #price-parcela-2{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-2 #price-parcela-2 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-2 #parcelas-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-2 #prefix-2{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img3-container{position:absolute;top:560px;left:1250px;width:480px;height:280px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-3{top:825px;left:1285px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-3,#titulo-3{color:#151515;position:absolute;overflow:hidden}#carac-3{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-3{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:935px;left:1340px;padding:10px 0}#container-price-3 #values-3{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-3 #preco-prazo-3{font-size:22px;margin:0;margin-left:24px}#container-price-3 #price-parcela-3{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-3 #price-parcela-3 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-3 #parcelas-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-3 #prefix-3{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img4-container{position:absolute;top:1140px;left:70px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-4{top:1445px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-4,#titulo-4{color:#151515;position:absolute;overflow:hidden}#carac-4{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-4{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1555px;left:145px;padding:10px 0}#container-price-4 #values-4{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-4 #preco-prazo-4{font-size:22px;margin:0;margin-left:24px}#container-price-4 #price-parcela-4{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-4 #price-parcela-4 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-4 #parcelas-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-4 #prefix-4{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img5-container{position:absolute;top:1140px;left:660px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-5{top:1445px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-5,#titulo-5{color:#151515;position:absolute;overflow:hidden}#carac-5{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-5{border:4px solid #151515;border-radius:55px;width:290px;position:absolute;top:1555px;left:750px;padding:10px 0}#container-price-5 #values-5{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-5 #preco-prazo-5{font-size:22px;margin:0;margin-left:24px}#container-price-5 #price-parcela-5{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-5 #price-parcela-5 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-5 #parcelas-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-5 #prefix-5{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img6-container{position:absolute;top:1140px;left:1250px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-6{top:1445px;left:1285px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:130px}#carac-6,#titulo-6{color:#151515;position:absolute;overflow:hidden}#carac-6{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-6{border:4px solid #151515;border-radius:55px;width:310px;position:absolute;top:1555px;left:1340px;padding:10px 0}#container-price-6 #values-6{color:#151515;font-size:28px;margin:0;margin-left:30px}#container-price-6 #preco-prazo-6{font-size:22px;margin:0;margin-left:24px}#container-price-6 #price-parcela-6{font-size:66px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-6 #price-parcela-6 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-6 #parcelas-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-6 #prefix-6{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img7-container{position:absolute;top:1740px;left:70px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-7{top:2040px;left:95px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-7,#titulo-7{color:#151515;position:absolute;overflow:hidden}#carac-7{top:1595px;left:200px;font-size:20px;text-align:right;width:412px;height:166px;display:none}#container-price-7{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:145px;padding:10px 0}#container-price-7 #values-7{color:#151515;font-size:24px;margin:0;margin-left:50px}#container-price-7 #preco-prazo-7{font-size:24px;margin:0;margin-left:24px}#container-price-7 #price-parcela-7{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-7 #price-parcela-7 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-7 #parcelas-7{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-7 #prefix-7{padding:0;margin:0;font-size:24px;line-height:1;margin-left:42px;margin-top:10px;color:#fa7b19}#img8-container{position:absolute;top:1740px;left:660px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-8{top:2040px;left:690px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-8,#titulo-8{color:#151515;position:absolute;overflow:hidden}#carac-8{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-8{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:740px;padding:10px 0}#container-price-8 #values-8{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-8 #preco-prazo-8{font-size:24px;margin:0;margin-left:24px}#container-price-8 #price-parcela-8{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-8 #price-parcela-8 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-8 #parcelas-8{padding:0;margin:0;font-size:24px;line-height:1;margin-left:38px;margin-top:10px}#container-price-8 #prefix-8{padding:0;margin:0;font-size:24px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#img9-container{position:absolute;top:1740px;left:1250px;width:480px;height:330px;overflow:hidden;display:flex;align-items:center;justify-content:center}#titulo-9{top:2040px;left:1280px;font-size:28px;text-transform:uppercase;font-weight:900;text-align:center;width:430px;height:90px}#carac-9,#titulo-9{color:#151515;position:absolute;overflow:hidden}#carac-9{top:1605px;left:835px;font-size:20px;text-align:right;width:392px;height:166px;display:none}#container-price-9{border:4px solid #151515;border-radius:55px;width:315px;position:absolute;top:2155px;left:1330px;padding:10px 0}#container-price-9 #values-9{color:#151515;font-size:26px;margin:0;margin-left:50px}#container-price-9 #preco-prazo-9{font-size:24px;margin:0;margin-left:24px}#container-price-9 #price-parcela-9{font-size:60px;margin:0;color:#fa7b19;line-height:1;margin-left:40px;font-weight:900}#container-price-9 #price-parcela-9 small{font-size:30px;margin:0;color:#fa7b19;position:absolute;top:56px;font-weight:900}#container-price-9 #parcelas-9{padding:0;margin:0;font-size:20px;line-height:1;margin-left:38px;margin-top:10px}#container-price-9 #prefix-9{padding:0;margin:0;font-size:20px;line-height:1;margin-left:44px;margin-top:10px;color:#fa7b19}#juridico{position:absolute;top:2508px;width:1663px;left:55px}#juridico p{margin:0;width:100%}#download{height:100vh;width:auto}.html2canvas-container{width:3000px!important;height:3000px!important}", ""]);

// exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML),expression:"showHTML"}],attrs:{"id":"contain-all"}},[_c('h3',{attrs:{"id":"chamada"},domProps:{"innerHTML":_vm._s(_vm.chamada)}}),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img1-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_1.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-1"},domProps:{"innerHTML":_vm._s(_vm.product_1.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-1"}},[_c('p',{attrs:{"id":"values-1"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_1.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-1"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-1"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-1"}},[_vm._v("\n                        "+_vm._s(_vm.product_1.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_1.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-1"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_1.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-1"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_1.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_1.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_1.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_1.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_1.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_1.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],class:{ img_2_tema_23: (this.theme != 'dga' && this.theme != 'ang') },attrs:{"id":"img2-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_2.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-2"},domProps:{"innerHTML":_vm._s(_vm.product_2.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-2"}},[_c('p',{attrs:{"id":"values-2"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_2.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-2"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-2"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-2"}},[_vm._v("\n                        "+_vm._s(_vm.product_2.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_2.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-2"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_2.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-2"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_2.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_2.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_2.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_2.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_2.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_2.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],class:{ img_3_tema_23: (this.theme != 'dga' && this.theme != 'ang') },attrs:{"id":"img3-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_3.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-3"},domProps:{"innerHTML":_vm._s(_vm.product_3.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-3"}},[_c('p',{attrs:{"id":"values-3"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_3.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-3"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-3"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-3"}},[_vm._v("\n                        "+_vm._s(_vm.product_3.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_3.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-3"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_3.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-3"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_3.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_3.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_3.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_3.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_3.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_3.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img4-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_4.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-4"},domProps:{"innerHTML":_vm._s(_vm.product_4.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-4"}},[_c('p',{attrs:{"id":"values-4"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_4.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-4"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-4"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-4"}},[_vm._v("\n                        "+_vm._s(_vm.product_4.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_4.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-4"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_4.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-4"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_4.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_4.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_4.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_4.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_4.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_4.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img5-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_5.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-5"},domProps:{"innerHTML":_vm._s(_vm.product_5.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-5"}},[_c('p',{attrs:{"id":"values-5"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_5.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-5"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-5"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-5"}},[_vm._v("\n                        "+_vm._s(_vm.product_5.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_5.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-5"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_5.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-5"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_5.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_5.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_5.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_5.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_5.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_5.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img6-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_6.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-6"},domProps:{"innerHTML":_vm._s(_vm.product_6.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-6"}},[_c('p',{attrs:{"id":"values-6"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_6.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-6"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-6"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-6"}},[_vm._v("\n                        "+_vm._s(_vm.product_6.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_6.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-6"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_6.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-6"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_6.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_6.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_6.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_6.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_6.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_6.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img7-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_7.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-7"},domProps:{"innerHTML":_vm._s(_vm.product_7.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-7"}},[_c('p',{attrs:{"id":"values-7"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_7.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-7"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-7"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-7"}},[_vm._v("\n                        "+_vm._s(_vm.product_7.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_7.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-7"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_7.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-7"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_7.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_7.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_7.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_7.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_7.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_7.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img8-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_8.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-8"},domProps:{"innerHTML":_vm._s(_vm.product_8.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-8"},domProps:{"innerHTML":_vm._s(_vm.product_8.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-8"}},[_c('p',{attrs:{"id":"values-8"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_8.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-8"}},[_vm._v(_vm._s(_vm.product_8.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-8"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-8"}},[_vm._v("\n                        "+_vm._s(_vm.product_8.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_8.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-8"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_8.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-8"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_8.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_8.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_8.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_8.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_8.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_8.forward_price))])]),_vm._v(" "),_c('div',{directives:[{name:"resize-image",rawName:"v-resize-image"}],attrs:{"id":"img9-container"}},[_c('img',{attrs:{"src":'https://circular.rxy.com.br/api/public/imgs/' + _vm.product_9.code + '_face.png'},on:{"load":_vm.incrementLoad}})]),_vm._v(" "),_c('p',{attrs:{"id":"titulo-9"},domProps:{"innerHTML":_vm._s(_vm.product_9.name)}}),_vm._v(" "),_c('p',{attrs:{"id":"carac-9"},domProps:{"innerHTML":_vm._s(_vm.product_9.feature)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme === 'vqt'),expression:"this.theme === 'vqt'"}],attrs:{"id":"container-price-9"}},[_c('p',{attrs:{"id":"values-9"}},[_vm._v("\n                à vista: "+_vm._s(_vm.product_9.sight_price)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"70px"}},[_c('div',{staticStyle:{"width":"25%","float":"left"}},[_c('p',{attrs:{"id":"parcelas-9"}},[_vm._v(_vm._s(_vm.product_9.payment_x)+"x")]),_vm._v(" "),_c('p',{attrs:{"id":"prefix-9"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","float":"left"}},[_c('p',{attrs:{"id":"price-parcela-9"}},[_vm._v("\n                        "+_vm._s(_vm.product_9.payment_price)+","),_c('small',[_vm._v(_vm._s(_vm.product_9.payment_price_cents))])])])]),_vm._v(" "),_c('p',{attrs:{"id":"preco-prazo-9"}},[_vm._v("\n                Total a prazo "+_vm._s(_vm.product_9.forward_price)+"\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.theme != 'vqt'),expression:"this.theme != 'vqt'"}],attrs:{"id":"container-price-theme-23-9"}},[_c('div',{staticStyle:{"width":"30%","float":"left","line-height":"0"}},[_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.product_9.payment_x)+"x")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","color":"#2c46f6","font-family":"Segoe UI Bold"}},[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left","padding-top":"5px"}},[_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"96px","font-weight":"bold","color":"#2c46f6","line-height":"0.6"}},[_vm._v(_vm._s(_vm.product_9.payment_price)),_c('span',{staticStyle:{"font-family":"Segoe UI Bold","font-size":"38px","font-weight":"bold","position":"absolute","top":"0","transform":"translateY(50%)"}},[_vm._v(","+_vm._s(_vm.product_9.payment_price_cents))])])]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.product_9.options_buy)}}),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-family":"Segoe UI Bold","font-size":"22px","font-wight":"bold","color":"#2c46f6","float":"left","width":"100%"}},[_vm._v("À VISTA "+_vm._s(_vm.product_9.sight_price))]),_vm._v(" "),_c('p',{staticClass:"reset",staticStyle:{"font-size":"16px","float":"left","width":"100%"}},[_vm._v("Total a prazo "+_vm._s(_vm.product_9.forward_price))])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(14)("./" + this.banner + '.png'),"id":"banner","alt":""},on:{"load":_vm.incrementLoad}}),_vm._v(" "),_c('div',{attrs:{"id":"juridico"}},[_c('p',[_vm._v(_vm._s(_vm.juridico))])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHTML === false && _vm.url === null),expression:"showHTML === false && url === null"}]},[_vm._v("Imagem sendo gerada, aguarde...")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticClass:"responsive-img",attrs:{"src":_vm.url,"alt":"Imagem para Download","height":"700px"}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#039be5","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":_vm.url,"target":"_blank","download":""}},[_vm._v("Baixar imagem")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url !== null),expression:"url !== null"}],staticStyle:{"background":"#EE0000","color":"#fff","padding":"10px 10px","border-radius":"5px"},attrs:{"href":"/"}},[_vm._v("Voltar para tela inicial")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js